/* ============================================================================
 * SleepHappy Phase 2 — Tier-based Installment + Sticky ATC Enhancement
 * ----------------------------------------------------------------------------
 *  Features:
 *    • Real 2C2P tier logic (4/6/10 months based on cart/product price)
 *    • Bilingual TH / EN (auto-detect via <html lang> or Shopify.locale)
 *    • Responsive: Mobile (<768) · Tablet (768–1023) · Desktop (≥1024)
 *    • Installment ribbon above existing <hdt-sticky-btn-atc>
 *    • Modal with tier-aware messaging
 *    • PDP price badge
 *    • Threshold rescue ("add X more to unlock Y months")
 *    • Checkout clarity banner on /cart
 *  Theme: HaloThemes Hydrogen — non-invasive overlay pattern
 *  Rollback: remove {% render 'sh-installment-suite' %} from theme.liquid
 * ========================================================================== */
(function () {
  'use strict';

  // ─── 1. TIER CONFIG (source of truth — real 2C2P data) ──────────────────
  const TIERS = [
    { min: 0,    max: 2999.99,  months: 0  },
    { min: 3000, max: 3499.99,  months: 4  },
    { min: 3500, max: 4999.99,  months: 6  },
    { min: 5000, max: Infinity, months: 10 },
  ];

  const CONFIG = {
    rescueThreshold: 500,     // ribbon: show "add X more" if gap ≤ this
    rescueMaxGap: 1000,       // PDP badge: hide rescue when gap > this
    scrollShowThreshold: 400,
  };

  function getTier(baht) {
    return TIERS.find(t => baht >= t.min && baht <= t.max) || TIERS[0];
  }
  function getNextTier(baht) {
    const curr = getTier(baht);
    const idx = TIERS.indexOf(curr);
    return TIERS[idx + 1] || null;
  }

  // ─── 2. i18n ─────────────────────────────────────────────────────────────
  function detectLocale() {
    const shopifyLocale = (window.Shopify && window.Shopify.locale) || '';
    const htmlLang = document.documentElement.lang || '';
    const raw = (shopifyLocale || htmlLang || 'th').toLowerCase();
    return raw.startsWith('en') ? 'en' : 'th';
  }
  const LOCALE = detectLocale();

  const I18N = {
    th: {
      ribbonAvail:   (mo, price) => `ผ่อน 0% นาน ${mo} เดือน เพียง <b>${price}</b>/เดือน`,
      ribbonRescue:  (mo, gap)   => `เพิ่มอีก <b>${gap}</b> ปลดล็อกผ่อน ${mo} เดือน`,
      ribbonUnavail: (gap)       => `เพิ่มอีก <b>${gap}</b> รับสิทธิ์ผ่อน 0%`,
      ribbonCta:     'ดูรายละเอียด',
      modalTitleOK:  (mo) => `ผ่อน 0% นาน ${mo} เดือน`,
      modalTitleNo:  'ยังไม่เข้าเกณฑ์ผ่อน 0%',
      priceLabel:    'ราคาสินค้า',
      monthlyLabel:  'ผ่อนเพียง',
      monthlyMeta:   (mo) => `ต่อเดือน × ${mo} เดือน · ดอกเบี้ย 0%`,
      noInstMsg:     'สินค้าราคาต่ำกว่า ฿3,000 ยังไม่สามารถผ่อน 0% ได้<br>เพิ่มสินค้าในตะกร้าให้ถึง ฿3,000 เพื่อรับสิทธิ์',
      tierTable:     'เกณฑ์ผ่อน 0%',
      tierRows: [
        { range: '฿3,000 – ฿3,499',     months: '4 เดือน'  },
        { range: '฿3,500 – ฿4,999',     months: '6 เดือน'  },
        { range: '฿5,000 ขึ้นไป',        months: '10 เดือน' },
      ],
      cardsLabel:    'รองรับบัตรเครดิต',
      reassure:      'เลือกผ่อน 0% ได้ที่หน้าชำระเงิน — ยังไม่มีการเรียกเก็บเงินในขั้นตอนนี้',
      cta:           'ใส่ตะกร้า — เลือกผ่อนตอนชำระเงิน',
      terms:         '* เงื่อนไขผ่อน 0% เป็นไปตามข้อกำหนดของธนาคารผู้ออกบัตร',
      termsCancel:   '* หากลูกค้ายกเลิกคำสั่งซื้อเอง (เช่น เปลี่ยนใจ) หลังชำระแบบผ่อน 0% แล้ว ยอดเงินคืนจะถูกหักค่าธรรมเนียมการผ่อนชำระที่ธนาคารเรียกเก็บไปแล้ว จึงไม่สามารถคืนเงินเต็มจำนวนได้ · กรณีสินค้ามีปัญหาหรือจัดส่งผิดจากทางร้าน คืนเงินเต็มจำนวน',
      pdpBadge:      (mo, price) => `ผ่อน 0% เพียง <b>${price}</b>/เดือน × ${mo} เดือน`,
      pdpLink:       'ดูรายละเอียด →',
      checkoutBar:   'คุณสามารถเลือกผ่อน 0% ได้ที่หน้าชำระเงิน — ยังไม่มีการเรียกเก็บเงิน',
      close:         'ปิด',
      lineInst:      (mo, price) => `ผ่อน 0% นาน ${mo} เดือน เพียง <b>${price}</b>/เดือน`,
      lineNoInst:    'สินค้านี้ยังไม่เข้าเกณฑ์ผ่อน 0%',
      // Cart line / bundle hint pieces (split layout: hero ฿/per + sub line)
      linePer:       '/เดือน',
      lineSub:       (mo) => `ผ่อน ${mo} เดือน · ดอกเบี้ย 0%`,
      bundleUnavailSub: (gap) => `เพิ่มอีก <b>${gap}</b> เพื่อรับสิทธิ์ผ่อน 0%`,
      // Cart-total summary block above subtotal
      cartSumLabel:  'ผ่อนเพียง',
      cartSumPer:    '/เดือน',
      cartSumSub:    (mo) => `ผ่อน 0% นาน ${mo} เดือน · เลือกได้ที่หน้าชำระเงิน`,
      cartSumUnavailHero: (gap) => `เพิ่มอีก <b>${gap}</b> รับสิทธิ์ผ่อน 0%`,
      cartSumUnavailSub:  'ยอดขั้นต่ำ ฿3,000 เพื่อเลือกผ่อน 0%',
      cartSumCta:    'ดูรายละเอียด',
    },
    en: {
      ribbonAvail:   (mo, price) => `0% installment ${mo} months · <b>${price}</b>/mo`,
      ribbonRescue:  (mo, gap)   => `Add <b>${gap}</b> more to unlock ${mo}-month plan`,
      ribbonUnavail: (gap)       => `Add <b>${gap}</b> more to unlock 0% installment`,
      ribbonCta:     'Details',
      modalTitleOK:  (mo) => `0% Installment · ${mo} months`,
      modalTitleNo:  'Not eligible for 0% installment',
      priceLabel:    'Product price',
      monthlyLabel:  'Pay only',
      monthlyMeta:   (mo) => `per month × ${mo} months · 0% interest`,
      noInstMsg:     'Items under ฿3,000 are not eligible for 0% installment.<br>Add more items to reach ฿3,000 to qualify.',
      tierTable:     '0% Installment Tiers',
      tierRows: [
        { range: '฿3,000 – ฿3,499',     months: '4 months'  },
        { range: '฿3,500 – ฿4,999',     months: '6 months'  },
        { range: '฿5,000 and above',    months: '10 months' },
      ],
      cardsLabel:    'Supported cards',
      reassure:      'Select 0% installment at checkout — no charges at this step',
      cta:           'Add to cart — choose installment at checkout',
      terms:         '* 0% installment terms subject to card issuer policy',
      termsCancel:   '* If you cancel your order yourself (e.g. change of mind) after paying by 0% installment, the refund will be reduced by the installment fees already charged by the bank, so a full refund is not possible. If the issue is on our side (defective item / wrong delivery), you receive a full refund.',
      pdpBadge:      (mo, price) => `0% installment <b>${price}</b>/mo × ${mo} months`,
      pdpLink:       'View details →',
      checkoutBar:   'You can choose 0% installment at checkout — no charges yet',
      close:         'Close',
      lineInst:      (mo, price) => `0% installment ${mo} months · <b>${price}</b>/mo`,
      lineNoInst:    'This item is not yet eligible for 0% installment',
      linePer:       '/mo',
      lineSub:       (mo) => `${mo} months · 0% interest`,
      bundleUnavailSub: (gap) => `Add <b>${gap}</b> more to unlock 0% installment`,
      cartSumLabel:  'Pay only',
      cartSumPer:    '/mo',
      cartSumSub:    (mo) => `0% installment for ${mo} months · choose at checkout`,
      cartSumUnavailHero: (gap) => `Add <b>${gap}</b> more to unlock 0% installment`,
      cartSumUnavailSub:  'Minimum ฿3,000 required for 0% installment',
      cartSumCta:    'Details',
    },
  };
  const T = I18N[LOCALE];

  // ─── 3. FORMATTING UTILS ─────────────────────────────────────────────────
  const fmtTHB = (baht) => '฿' + Math.ceil(baht).toLocaleString(LOCALE === 'en' ? 'en-US' : 'th-TH');
  const centsToBaht = (c) => c / 100;
  const monthlyCost = (baht, months) => months > 0 ? Math.ceil(baht / months) : 0;

  const isProductPage = () => document.body.classList.contains('template-product');
  const isCartPage = () => /\/cart/.test(location.pathname) && !/\/checkouts?\//.test(location.pathname);

  // ─── 4. STATE ────────────────────────────────────────────────────────────
  let currentPriceCents = 0;
  let productVariantId = null;
  let currentProductTitle = '';

  // Cart state (mirror of Shopify cart). Updated via refreshLineItems()
  // and refreshCartState(). Drives Check out/ATC button visibility and the
  // ribbon's "use cart total when cart has items" rule.
  const cartState = { item_count: 0, total_price: 0, items: [] };

  function isVariantInCart(vid) {
    if (!vid) return false;
    const idStr = String(vid);
    return cartState.items.some(i => String(i.variant_id) === idStr);
  }

  function applyCartStateClasses() {
    const body = document.body;
    if (!body) return;
    body.classList.toggle('sh-cart-has-items', cartState.item_count > 0);
    body.classList.toggle('sh-cart-empty', cartState.item_count === 0);
    body.classList.toggle('sh-variant-in-cart', isVariantInCart(productVariantId));
  }

  function refreshCartState() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(r => r.ok ? r.json() : null)
      .then(cart => {
        if (cart) {
          cartState.item_count = cart.item_count || 0;
          cartState.total_price = cart.total_price || 0;
          cartState.items = Array.isArray(cart.items) ? cart.items : [];
        }
        applyCartStateClasses();
        return cart;
      })
      .catch(() => null);
  }

  // Inline SVG card logos (no external deps)
  const CARD_LOGOS = {
    visa: '<svg viewBox="0 0 48 32" xmlns="http://www.w3.org/2000/svg"><rect width="48" height="32" rx="4" fill="#1A1F71"/><text x="24" y="21" text-anchor="middle" font-family="Arial,sans-serif" font-size="11" font-weight="900" fill="#fff" font-style="italic">VISA</text></svg>',
    mastercard: '<svg viewBox="0 0 48 32" xmlns="http://www.w3.org/2000/svg"><rect width="48" height="32" rx="4" fill="#fff" stroke="#E5E7EB"/><circle cx="20" cy="16" r="8" fill="#EB001B"/><circle cx="28" cy="16" r="8" fill="#F79E1B" fill-opacity="0.9"/><path d="M24 10.5a8 8 0 0 1 0 11 8 8 0 0 1 0-11z" fill="#FF5F00"/></svg>',
    jcb: '<svg viewBox="0 0 48 32" xmlns="http://www.w3.org/2000/svg"><rect width="48" height="32" rx="4" fill="#fff" stroke="#E5E7EB"/><rect x="8" y="10" width="10" height="12" rx="2" fill="#0E4C96"/><rect x="19" y="10" width="10" height="12" rx="2" fill="#BF0032"/><rect x="30" y="10" width="10" height="12" rx="2" fill="#00A050"/><text x="24" y="19.5" text-anchor="middle" font-family="Arial,sans-serif" font-size="6" font-weight="900" fill="#fff">JCB</text></svg>',
    amex: '<svg viewBox="0 0 48 32" xmlns="http://www.w3.org/2000/svg"><rect width="48" height="32" rx="4" fill="#2E77BC"/><text x="24" y="19.5" text-anchor="middle" font-family="Arial,sans-serif" font-size="8" font-weight="900" fill="#fff" letter-spacing="0.3">AMEX</text></svg>',
  };

  // ─── 5. READ CURRENT PRICE (robust across theme patterns) ────────────────
  function readCurrentPrice() {
    // Priority 1: er-buyx-gety bundle card — when present, its dropdown is
    // what the user actually interacts with on this PDP, so it is the
    // authoritative source. This keeps the PDP badge + sticky ribbon in
    // lockstep with the bundle selection shown right next to them.
    const bundleCard = document.querySelector('.er-buyx-gety__pr-item-buy');
    if (bundleCard) {
      try {
        const variantsJson = bundleCard.getAttribute('data-variants');
        // The widget keeps the authoritative choice in its <select> value;
        // data-current-id is only the initial default, not kept in sync.
        const sel = bundleCard.querySelector('select[name="er-buyx-gety__select"]');
        const currentId = (sel && sel.value) || bundleCard.getAttribute('data-current-id');
        if (variantsJson && currentId) {
          const variants = JSON.parse(variantsJson);
          const match = variants.find(v => String(v.id) === String(currentId));
          if (match && match.price) {
            currentPriceCents = match.price;
            productVariantId = match.id;
            return;
          }
        }
      } catch (_) { /* fall through */ }
    }

    // Most reliable signal: the variant picker's CHECKED radios + the
    // __SH_product variants map. HaloThemes renders multiple <input
    // name="id"> elements (one stale from initial URL, one updated on
    // change, plus a SELECT) — picking the "first non-empty" gives a
    // stale variant ID on TH locale. Matching checked radios to the
    // variants array side-steps the issue entirely.
    if (window.__SH_product && window.__SH_product.variants) {
      const variants = window.__SH_product.variants;
      const checkedRadios = [...document.querySelectorAll(
        'fieldset input[type="radio"]:checked, ' +
        '[class*="variant-picker"] input[type="radio"]:checked, ' +
        'hdt-variant-picker input[type="radio"]:checked'
      )];
      if (checkedRadios.length) {
        // For multi-option products (e.g. Color / Size) the variant.title is
        // "Red / Large". Match a variant whose title contains every checked
        // option value.
        const checkedValues = checkedRadios.map(r => r.value);
        const match = variants.find(v => {
          const titleParts = (v.title || '').split(' / ').map(s => s.trim());
          return checkedValues.every(val => titleParts.includes(val));
        });
        if (match && match.price != null) {
          currentPriceCents = match.price;
          productVariantId = String(match.id);
          return;
        }
      }
    }

    // Fallback 1: prefer SELECT (live variant on most themes), then any
    // non-empty input. Skip the FIRST input on HaloThemes — it can hold a
    // stale ID from the initial URL load and never updates.
    const select = document.querySelector('form[action*="/cart/add"] select[name="id"]');
    let resolvedId = '';
    if (select && select.value && select.value.trim()) {
      resolvedId = select.value.trim();
    } else {
      const idInputs = [...document.querySelectorAll('form[action*="/cart/add"] input[name="id"]')];
      // Prefer the LAST input with a value (most recently updated on
      // HaloThemes layouts where multiple inputs coexist).
      for (let i = idInputs.length - 1; i >= 0; i--) {
        if (idInputs[i].value && idInputs[i].value.trim()) {
          resolvedId = idInputs[i].value.trim();
          break;
        }
      }
    }
    if (resolvedId) productVariantId = resolvedId;

    if (window.__SH_product) {
      const variants = window.__SH_product.variants || [];
      const match = variants.find(v => String(v.id) === String(productVariantId)) || variants[0];
      if (match && match.price != null) { currentPriceCents = match.price; return; }
    }

    // Fallback 2: scrape the visible price text. Includes HaloThemes
    // selectors so we don't fall back to ฿0 on this theme family.
    const priceEl =
      document.querySelector('.hdt-price-item--sale, .hdt-price__sale .hdt-price-item') ||
      document.querySelector('.hdt-product__price .hdt-price-item--sale') ||
      document.querySelector('.hdt-product__price') ||
      document.querySelector('.price-item--sale, .price__regular .price-item, [class*="price__regular"]');
    const priceText = priceEl ? priceEl.textContent : '';
    // Pull the last price-shaped number (sale price typically appears after regular)
    const matches = priceText.match(/[\d,]+(\.\d+)?/g);
    if (matches && matches.length) {
      // Pick smallest non-zero number (likely the sale price)
      const nums = matches.map(s => parseFloat(s.replace(/,/g, ''))).filter(n => n > 0);
      if (nums.length) currentPriceCents = Math.min(...nums) * 100;
    }
  }

  // ─── 5a. READ QUANTITY & PRODUCT TITLE ────────────────────────────────────
  function readCurrentQuantity() {
    // HaloThemes renders multiple qty inputs (main form + sticky ATC bar +
    // mini cart). Picking the first one in DOM order returns a stale "1"
    // even after the user clicked + on the visible stepper. Strategy:
    //   1. Prefer the input that's actually visible on screen.
    //   2. Otherwise pick the one with the highest value (live > stale 1).
    const inputs = [...document.querySelectorAll(
      'form[action*="/cart/add"] input[name="quantity"], ' +
      '.product-form input[type="number"], ' +
      '.quantity__input, ' +
      '[name="quantity"]'
    )].filter(i => i.type === 'number' || i.type === 'text' || !i.type);
    if (!inputs.length) return 1;

    // 1. Visible input wins (the one the user can see + click)
    const visible = inputs.find(i => {
      const r = i.getBoundingClientRect();
      const cs = getComputedStyle(i);
      return r.width > 0 && r.height > 0 && cs.visibility !== 'hidden' && cs.display !== 'none';
    });
    if (visible) return Math.max(1, parseInt(visible.value || '1', 10) || 1);

    // 2. Highest value (live qty > stale defaults)
    let best = 1;
    for (const i of inputs) {
      const v = parseInt(i.value || '0', 10) || 0;
      if (v > best) best = v;
    }
    return Math.max(1, best);
  }

  function readProductTitle() {
    if (currentProductTitle) return currentProductTitle;
    const titleEl = document.querySelector(
      '.product__title, h1.product-title, [class*="product__title"], ' +
      '.product-single__title, main h1'
    );
    currentProductTitle = titleEl ? titleEl.textContent.trim() : '';
    // Truncate to ~40 chars for ribbon display
    if (currentProductTitle.length > 40) {
      currentProductTitle = currentProductTitle.substring(0, 38) + '…';
    }
    return currentProductTitle;
  }

  // Pull the main product image once. Try the OpenGraph tag first (always
  // the canonical product image), then fall back to the first product-media
  // <img>. Returned URL is rewritten to a small CDN size to keep the ribbon
  // thumbnail snappy on mobile.
  function readProductImage() {
    const og = document.querySelector('meta[property="og:image"]')?.content;
    let src = og;
    if (!src) {
      const img = document.querySelector(
        '.product__media img, .product-media img, [class*="product__media"] img, ' +
        '.product-single__photo img, .product-image img, .product__image img, ' +
        'main img[src*="cdn.shopify.com/s/files"]'
      );
      src = img?.currentSrc || img?.src || img?.dataset?.src || '';
    }
    if (!src) return '';
    // Force https — og:image often has http on Thai stores
    if (src.startsWith('http://')) src = 'https:' + src.slice(5);
    if (src.startsWith('//')) src = 'https:' + src;
    // Rewrite Shopify CDN URL to a 120x thumbnail (saves bandwidth, sharper on retina)
    return src.replace(/(_\d+x\d*|_\d+x|_x\d+)?(\.(jpg|jpeg|png|webp|gif))(\?.*)?$/i, '_120x$2$4');
  }

  /** Total price (cents) = unit price × quantity, for PDP installment calculations */
  function getTotalPriceCents() {
    return currentPriceCents * readCurrentQuantity();
  }

  // ─── 6. MODAL ────────────────────────────────────────────────────────────
  function buildModal() {
    if (document.getElementById('sh-inst-modal')) return;
    const logos = ['visa', 'mastercard', 'jcb', 'amex'].map(k => `<div class="sh-inst-card-logo">${CARD_LOGOS[k]}</div>`).join('');
    const tierRowsHtml = T.tierRows.map(r => `<tr><td>${r.range}</td><td>${r.months}</td></tr>`).join('');

    const modal = document.createElement('div');
    modal.id = 'sh-inst-modal';
    modal.className = 'sh-inst-modal';
    modal.innerHTML = `
      <div class="sh-inst-modal__box" role="dialog" aria-modal="true" aria-labelledby="sh-inst-title">
        <div class="sh-inst-modal__header">
          <h3 class="sh-inst-modal__title" id="sh-inst-title" data-sh-title>—</h3>
          <button class="sh-inst-modal__close" aria-label="${T.close}" data-sh-close>✕</button>
        </div>

        <div class="sh-inst-price-card">
          <p class="sh-inst-price-card__label">${T.priceLabel}</p>
          <p class="sh-inst-price-card__value" data-sh-price>฿0</p>
        </div>

        <div class="sh-inst-result" data-sh-result>
          <p class="sh-inst-result__label">${T.monthlyLabel}</p>
          <p class="sh-inst-result__value" data-sh-monthly>฿0</p>
          <p class="sh-inst-result__meta" data-sh-monthly-meta>—</p>
        </div>

        <div class="sh-inst-noinst" data-sh-noinst style="display:none">
          ${T.noInstMsg}
        </div>

        <div class="sh-inst-tiertable">
          <p class="sh-inst-tiertable__label">${T.tierTable}</p>
          <table><tbody>${tierRowsHtml}</tbody></table>
        </div>

        <div class="sh-inst-cards">
          <p class="sh-inst-cards__label">${T.cardsLabel}</p>
          <div class="sh-inst-cards__list">${logos}</div>
        </div>

        <div class="sh-inst-reassure">${T.reassure}</div>

        <button class="sh-inst-cta" data-sh-add-to-cart>${T.cta}</button>
        <p class="sh-inst-terms">${T.terms}</p>
        <p class="sh-inst-terms">${T.termsCancel}</p>
      </div>
    `;
    document.body.appendChild(modal);

    modal.addEventListener('click', (e) => {
      if (e.target === modal || e.target.hasAttribute('data-sh-close')) closeModal();
    });
    modal.querySelector('[data-sh-add-to-cart]').addEventListener('click', addToCartFromModal);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });
  }

  function renderModal() {
    const totalCents = getTotalPriceCents();
    const baht = centsToBaht(totalCents);
    const tier = getTier(baht);
    const hasInst = tier.months > 0;

    const titleEl   = document.querySelector('[data-sh-title]');
    const priceEl   = document.querySelector('[data-sh-price]');
    const resultEl  = document.querySelector('[data-sh-result]');
    const noinstEl  = document.querySelector('[data-sh-noinst]');
    const monthlyEl = document.querySelector('[data-sh-monthly]');
    const metaEl    = document.querySelector('[data-sh-monthly-meta]');

    if (priceEl) priceEl.textContent = fmtTHB(baht);
    if (titleEl) titleEl.textContent = hasInst ? T.modalTitleOK(tier.months) : T.modalTitleNo;

    if (hasInst) {
      if (resultEl) resultEl.style.display = '';
      if (noinstEl) noinstEl.style.display = 'none';
      if (monthlyEl) monthlyEl.textContent = fmtTHB(monthlyCost(baht, tier.months));
      if (metaEl)    metaEl.textContent = T.monthlyMeta(tier.months);
    } else {
      if (resultEl) resultEl.style.display = 'none';
      if (noinstEl) noinstEl.style.display = '';
    }
  }

  function openModal() {
    readCurrentPrice();
    const modal = document.getElementById('sh-inst-modal');
    if (!modal) return;
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    renderModal();
  }
  function closeModal() {
    const modal = document.getElementById('sh-inst-modal');
    if (!modal) return;
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function addToCartFromModal() {
    if (!productVariantId) {
      const atcBtn = document.querySelector('button[name="add"]');
      if (atcBtn) atcBtn.click();
      closeModal();
      return;
    }
    const qty = readCurrentQuantity();
    location.href = `/cart/${productVariantId}:${qty}`;
  }

  // Smart Check out — the button only shows when cart has items, so we
  // always route to /cart for review first (builds trust vs. jumping to
  // /checkout and surprising detail-oriented shoppers). /cart has its own
  // Proceed-to-checkout CTA for one more click.
  function goToCheckout() {
    if (isProductPage()) readCurrentPrice();
    // If on PDP and current variant isn't in cart yet, add it first so the
    // customer's selection isn't lost when they hit the cart page.
    if (isProductPage() && productVariantId && !isVariantInCart(productVariantId)) {
      const qty = readCurrentQuantity();
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: productVariantId, quantity: qty })
      })
        .then(() => { location.href = '/cart'; })
        .catch(() => { location.href = '/cart'; });
      return;
    }
    location.href = '/cart';
  }

  // ─── 7. RIBBON (above sticky ATC) ────────────────────────────────────────
  function buildRibbon() {
    if (document.getElementById('sh-inst-ribbon')) return;
    const ribbon = document.createElement('div');
    ribbon.id = 'sh-inst-ribbon';
    ribbon.className = 'sh-inst-ribbon';
    ribbon.innerHTML = `
      <div class="sh-inst-ribbon__left">
        <svg class="sh-inst-ribbon__icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M20 4H4c-1.11 0-2 .89-2 2v12c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"/>
        </svg>
        <span class="sh-inst-ribbon__msg" data-sh-ribbon-msg>—</span>
        <div class="sh-inst-ribbon__cards" aria-hidden="true">
          <span class="sh-inst-ribbon__card">${CARD_LOGOS.visa}</span>
          <span class="sh-inst-ribbon__card">${CARD_LOGOS.mastercard}</span>
          <span class="sh-inst-ribbon__card">${CARD_LOGOS.jcb}</span>
          <span class="sh-inst-ribbon__card">${CARD_LOGOS.amex}</span>
        </div>
        <button class="sh-inst-ribbon__calc-btn" data-sh-open-inst type="button">${LOCALE === 'th' ? 'คำนวณผ่อน' : 'Calculate'}</button>
      </div>
      <div class="sh-inst-ribbon__right">
        <img class="sh-inst-ribbon__product-img" data-sh-ribbon-img alt="" decoding="async">
        <div class="sh-inst-ribbon__product">
          <span class="sh-inst-ribbon__product-name" data-sh-ribbon-product>—</span>
          <span class="sh-inst-ribbon__product-price" data-sh-ribbon-price>—</span>
          <span class="sh-inst-ribbon__product-qty" data-sh-ribbon-qty hidden></span>
        </div>
        <div class="sh-inst-ribbon__cta-group">
          <button class="sh-inst-ribbon__atc-btn" data-sh-ribbon-atc type="button">${LOCALE === 'th' ? 'ใส่ตะกร้า' : 'Add to cart'}</button>
          <button class="sh-inst-ribbon__checkout-btn" data-sh-ribbon-checkout type="button">${LOCALE === 'th' ? 'ชำระเงิน' : 'Check out'}</button>
        </div>
      </div>
    `;
    document.body.appendChild(ribbon);
    ribbon.querySelector('[data-sh-open-inst]').addEventListener('click', (e) => { e.stopPropagation(); openModal(); });
    ribbon.querySelector('.sh-inst-ribbon__left').addEventListener('click', openModal);
    ribbon.querySelector('[data-sh-ribbon-atc]').addEventListener('click', (e) => {
      e.stopPropagation();
      const atcBtn = document.querySelector('button[name="add"], .product-form__submit, [class*="add-to-cart"]');
      if (atcBtn) atcBtn.click();
    });
    ribbon.querySelector('[data-sh-ribbon-checkout]').addEventListener('click', (e) => {
      e.stopPropagation();
      goToCheckout();
    });
  }

  function updateRibbon() {
    const ribbon = document.getElementById('sh-inst-ribbon');
    const msgEl = document.querySelector('[data-sh-ribbon-msg]');
    if (!msgEl || !ribbon) return;

    // Source of truth for ribbon amount:
    //   • Cart has items → cart total (rolls up all SKUs; ribbon "follows"
    //     the customer across pages and reflects the real total they owe).
    //   • Cart empty + on PDP → current product × qty preview.
    //   • Cart empty + non-PDP → ribbon will be hidden by positionRibbon.
    const cartMode = cartState.item_count > 0;
    let baht;
    if (cartMode) {
      baht = centsToBaht(cartState.total_price);
      if (isProductPage()) readCurrentPrice(); // keep productVariantId fresh
    } else if (isProductPage()) {
      readCurrentPrice();
      baht = centsToBaht(getTotalPriceCents());
    } else {
      baht = 0;
    }

    const productNameEl  = document.querySelector('[data-sh-ribbon-product]');
    const productPriceEl = document.querySelector('[data-sh-ribbon-price]');
    const productImgEl   = document.querySelector('[data-sh-ribbon-img]');
    const productQtyEl   = document.querySelector('[data-sh-ribbon-qty]');

    if (productPriceEl) productPriceEl.textContent = fmtTHB(baht);

    // Right section: reflects cart when cart has items (so the ribbon is
    // a consistent cart summary across pages), else the current product
    // preview on PDPs.
    if (cartMode) {
      if (productNameEl) {
        const n = cartState.item_count;
        productNameEl.textContent = LOCALE === 'th'
          ? `${n} ชิ้นในตะกร้า`
          : `${n} ${n === 1 ? 'item' : 'items'} in cart`;
      }
      if (productQtyEl) { productQtyEl.textContent = ''; productQtyEl.hidden = true; }
      // Img hidden via CSS (.sh-cart-has-items) — no need to touch src.
    } else if (isProductPage()) {
      const qty = readCurrentQuantity();
      if (productNameEl) productNameEl.textContent = readProductTitle();
      if (productImgEl) {
        const src = readProductImage();
        if (src && productImgEl.dataset.lastSrc !== src) {
          productImgEl.src = src;
          productImgEl.dataset.lastSrc = src;
        }
        productImgEl.style.display = src ? '' : 'none';
      }
      if (productQtyEl) {
        if (qty > 1) {
          productQtyEl.textContent = LOCALE === 'th' ? `(${qty} ชิ้น)` : `(${qty} items)`;
          productQtyEl.hidden = false;
        } else {
          productQtyEl.textContent = '';
          productQtyEl.hidden = true;
        }
      }
    }

    const tier = getTier(baht);
    const next = getNextTier(baht);
    let html = '';
    if (tier.months > 0) {
      const perMonth = monthlyCost(baht, tier.months);
      if (next && (next.min - baht) <= CONFIG.rescueThreshold) {
        const gap = fmtTHB(next.min - baht);
        html = T.ribbonRescue(next.months, gap);
      } else {
        // In cart mode, prefix with "ยอดรวม/Cart" so the customer understands
        // the number rolls up every item in their cart, not just this product.
        const prefixTh = cartMode ? 'ยอดรวมตะกร้า · ' : '';
        const prefixEn = cartMode ? 'Cart total · ' : '';
        html = LOCALE === 'th'
          ? `${prefixTh}ผ่อน <b>${fmtTHB(perMonth)}</b>/เดือน × ${tier.months} เดือน · 0%`
          : `${prefixEn}Pay <b>${fmtTHB(perMonth)}</b>/mo × ${tier.months} months · 0%`;
      }
      ribbon.classList.remove('sh-inst-ribbon--unavail');
    } else {
      const gap = fmtTHB(3000 - baht);
      html = T.ribbonUnavail(gap);
      ribbon.classList.add('sh-inst-ribbon--unavail');
    }
    msgEl.innerHTML = html;
  }

  function positionRibbon() {
    const ribbon = document.getElementById('sh-inst-ribbon');
    if (!ribbon) return;

    const onPdp = isProductPage();
    const cartHasItems = cartState.item_count > 0;

    // Non-PDP: ribbon is intentionally hidden (replaced by the compact cart
    // FAB — see buildCartFab). Nothing to position, and we must NOT add
    // sh-has-ribbon because the chat widget uses it to offset its bottom.
    if (!onPdp) {
      ribbon.classList.remove('is-visible');
      document.body.classList.remove('sh-has-ribbon');
      return;
    }

    // PDP empty cart + not scrolled past threshold → hide ribbon
    if (!cartHasItems && window.scrollY <= CONFIG.scrollShowThreshold) {
      ribbon.classList.remove('is-visible');
      document.body.classList.remove('sh-has-ribbon');
      return;
    }

    // PDP: detect theme's sticky ATC (may or may not be present depending
    // on scroll position). We hide the theme's sticky ATC via CSS now, so
    // this branch rarely triggers, but keep the logic for safety.
    let atcShown = false;
    let atcHeight = 0;
    const stickyATC = document.querySelector('hdt-sticky-btn-atc');
    if (stickyATC) {
      const cs = getComputedStyle(stickyATC);
      const notHidden = cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity || '1') > 0.05;
      if (notHidden) {
        const r = stickyATC.getBoundingClientRect();
        const onScreen = r.top < window.innerHeight && r.bottom > 0 && r.height > 10;
        if (onScreen) { atcShown = true; atcHeight = r.height; }
      }
    }

    ribbon.style.bottom = atcShown ? (atcHeight + 'px') : '0px';
    ribbon.classList.add('is-visible');
    document.body.classList.add('sh-has-ribbon');
  }

  // rAF-throttled scroll handler so the ribbon reflows smoothly as the
  // theme's sticky ATC animates in/out during scrolling.
  let ribbonRafPending = false;
  function scheduleRibbonReposition() {
    if (ribbonRafPending) return;
    ribbonRafPending = true;
    requestAnimationFrame(() => {
      ribbonRafPending = false;
      positionRibbon();
    });
  }

  // ─── 8. PDP BADGE ────────────────────────────────────────────────────────
  // Bold navy-hero card with gold accent + amount + accepted card logos.
  // Two modes:
  //   • Eligible (≥ ฿3,000) → show per-month installment for current variant
  //   • Sub-threshold       → show "add ฿X to cart to unlock 0% installment"
  //                           so pillow / accessory pages still get a badge
  //                           that encourages bundle upsell
  const cardLogosHtml = () => `
    <span class="sh-pdp-inst-badge__cards" aria-hidden="true">
      <span class="sh-pdp-inst-badge__card">${CARD_LOGOS.visa}</span>
      <span class="sh-pdp-inst-badge__card">${CARD_LOGOS.mastercard}</span>
      <span class="sh-pdp-inst-badge__card">${CARD_LOGOS.jcb}</span>
      <span class="sh-pdp-inst-badge__card">${CARD_LOGOS.amex}</span>
    </span>
  `;
  function pdpBadgeBodyHtml(months, perMonth) {
    const per = LOCALE === 'th' ? '/เดือน' : '/mo';
    const label = LOCALE === 'th' ? 'ผ่อน 0%' : '0% INSTALLMENT';
    const sub = LOCALE === 'th'
      ? `นาน ${months} เดือน · บัตรเครดิตทุกธนาคาร`
      : `For ${months} months · All major cards`;
    return `
      <span class="sh-pdp-inst-badge__label">${label}</span>
      <span class="sh-pdp-inst-badge__hero">
        <span class="sh-pdp-inst-badge__amount">${fmtTHB(perMonth)}</span><span class="sh-pdp-inst-badge__per">${per}</span>
      </span>
      <span class="sh-pdp-inst-badge__subline">
        <span class="sh-pdp-inst-badge__sub">${sub}</span>
        ${cardLogosHtml()}
      </span>
    `;
  }
  function pdpBadgeRescueHtml(gapBaht) {
    const label = LOCALE === 'th' ? 'ผ่อน 0% · ปลดล็อกได้!' : 'UNLOCK 0% INSTALLMENT';
    const sub = LOCALE === 'th'
      ? `เพิ่มสินค้าให้ยอดรวมครบ ฿3,000 รับสิทธิ์ผ่อน 0% นาน 4 เดือน · บัตรเครดิตทุกธนาคาร`
      : `Reach ฿3,000 cart total to unlock 0% installment for 4 months · All major cards`;
    const heroLabel = LOCALE === 'th' ? 'เพิ่มอีก' : 'Add';
    const heroSub  = LOCALE === 'th' ? 'เพื่อรับสิทธิ์' : 'to unlock';
    return `
      <span class="sh-pdp-inst-badge__label">${label}</span>
      <span class="sh-pdp-inst-badge__hero">
        <span class="sh-pdp-inst-badge__amount">+${fmtTHB(gapBaht)}</span><span class="sh-pdp-inst-badge__per">${heroSub}</span>
      </span>
      <span class="sh-pdp-inst-badge__subline">
        <span class="sh-pdp-inst-badge__sub">${sub}</span>
        ${cardLogosHtml()}
      </span>
    `;
  }

  function buildPdpBadge() {
    if (!isProductPage()) return;
    if (document.querySelector('.sh-pdp-inst-badge')) return;

    readCurrentPrice();
    // Total customer will pay (price × qty) — matches ribbon source of truth.
    const baht = centsToBaht(getTotalPriceCents());
    const tier = getTier(baht);
    const isRescue = tier.months === 0;
    const gapBaht = isRescue ? Math.max(1, 3000 - baht) : 0;
    // Smart visibility: only show the rescue badge when the gap is small
    // enough that bundling one more item is realistic. For ฿790 pillows
    // needing +฿2,210, a "Reach ฿3,000" pitch is more confusing than helpful.
    if (isRescue && gapBaht > CONFIG.rescueMaxGap) return false;

    const perMonth = isRescue ? 0 : monthlyCost(baht, tier.months);

    // Find the best insertion point. We try a long list of selectors in
    // priority order so the badge appears on every product layout the
    // theme might render — pill swatches, custom variant lists, dropdown
    // selects, single-variant products, etc.
    const pickVisible = (sels) => {
      for (const sel of sels) {
        const els = document.querySelectorAll(sel);
        for (const el of els) {
          const r = el.getBoundingClientRect();
          if (r.height > 10 && r.width > 10) return el;
        }
      }
      return null;
    };
    const variantPicker = pickVisible([
      '.custom-variant-picker',
      '.hdt-product-info__item.hdt-product__variant-picker',
      '.hdt-product__variant-picker',
      '[class*="variant-picker"]:not(hdt-variant-picker)',
      'fieldset[data-index="0"]',
    ]);
    const priceContainer = pickVisible([
      '.hdt-product-info__item.hdt-product__price',
      '.hdt-product__price',
      '.hdt-price-wrapp',
      '.product__info .price:not(hdt-sticky-btn-atc .price)',
      '.product-form__info .price',
      'main .price--large',
      'main [class*="price__container"]',
    ]);
    // Last-resort: any product info column / form so the badge ALWAYS
    // shows up somewhere reasonable on eligible products.
    const productInfo = pickVisible([
      '.hdt-product-info__list',
      '.product__info',
      '.product-form',
      'product-info',
      'main .product',
    ]);

    const badge = document.createElement('div');
    badge.className = 'sh-pdp-inst-badge sh-pdp-inst-badge--block' + (isRescue ? ' sh-pdp-inst-badge--rescue' : '');
    badge.setAttribute('role', 'button');
    badge.setAttribute('tabindex', '0');
    badge.innerHTML = `
      <div class="sh-pdp-inst-badge__icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="2" y="5" width="20" height="14" rx="2"/>
          <line x1="2" y1="10" x2="22" y2="10"/>
          <line x1="6" y1="15" x2="10" y2="15"/>
        </svg>
      </div>
      <div class="sh-pdp-inst-badge__body" data-sh-pdp-text>
        ${isRescue ? pdpBadgeRescueHtml(gapBaht) : pdpBadgeBodyHtml(tier.months, perMonth)}
      </div>
      <div class="sh-pdp-inst-badge__chevron" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="9 18 15 12 9 6"/>
        </svg>
      </div>
    `;
    badge.addEventListener('click', openModal);
    badge.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openModal(); } });

    /* Insertion priority — sit RIGHT BEFORE the buy buttons (just under
       the quantity selector) so the installment value reads as the final
       reassurance before the customer clicks Add to cart / Buy now. */
    const buyButton = pickVisible([
      '.hdt-product-info__item.hdt-product__buy-button',
      '.hdt-product__buy-button',
      'form[action*="/cart/add"] [class*="buy-button"]',
      '.product-form__buttons',
      'form[action*="/cart/add"] .product-form__submit'
    ]);
    if (buyButton && buyButton.parentNode) {
      const wrap = buyButton.closest('.hdt-product-info__item') || buyButton;
      wrap.parentNode.insertBefore(badge, wrap);
      return true;
    }
    /* Fallback: after quantity selector */
    const qty = pickVisible([
      '.hdt-product-info__item:has(input[name="quantity"])',
      '.hdt-product-info__item:has([class*="quantity"])',
      '[class*="quantity-selector"]',
      'input[name="quantity"]'
    ]);
    if (qty && qty.parentNode) {
      const wrap = qty.closest('.hdt-product-info__item') || qty;
      wrap.parentNode.insertBefore(badge, wrap.nextSibling);
      return true;
    }
    /* Legacy fallbacks */
    if (variantPicker && variantPicker.parentNode) {
      const wrap = variantPicker.closest('.hdt-product-info__item') || variantPicker;
      wrap.parentNode.insertBefore(badge, wrap.nextSibling);
    } else if (priceContainer && priceContainer.parentNode) {
      const wrap = priceContainer.closest('.hdt-product-info__item') || priceContainer;
      wrap.parentNode.insertBefore(badge, wrap.nextSibling);
    } else if (productInfo) {
      productInfo.appendChild(badge);
    } else {
      return false;
    }
    return true;
  }

  function updatePdpBadge() {
    const el = document.querySelector('[data-sh-pdp-text]');
    if (!el) { buildPdpBadge(); return; }
    const card = el.closest('.sh-pdp-inst-badge');
    const baht = centsToBaht(getTotalPriceCents());
    const tier = getTier(baht);
    if (tier.months === 0) {
      // Sub-threshold → rescue mode, but only if the gap is small enough
      // that bundling one more item is realistic.
      const gapBaht = Math.max(1, 3000 - baht);
      if (gapBaht > CONFIG.rescueMaxGap) {
        card.style.display = 'none';
        return;
      }
      card.style.display = '';
      card.classList.add('sh-pdp-inst-badge--rescue');
      el.innerHTML = pdpBadgeRescueHtml(gapBaht);
      return;
    }
    card.style.display = '';
    card.classList.remove('sh-pdp-inst-badge--rescue');
    const perMonth = monthlyCost(baht, tier.months);
    el.innerHTML = pdpBadgeBodyHtml(tier.months, perMonth);
  }

  // ─── 9. CHECKOUT CLARITY BAR ─────────────────────────────────────────────
  function buildCheckoutBar() {
    if (!isCartPage()) return;
    if (document.getElementById('sh-checkout-bar')) return;
    const bar = document.createElement('div');
    bar.id = 'sh-checkout-bar';
    bar.className = 'sh-checkout-bar is-visible';
    bar.innerHTML = `<span class="sh-checkout-bar__icon" aria-hidden="true">💳</span>${T.checkoutBar}`;
    const main = document.querySelector('main') || document.body;
    main.insertBefore(bar, main.firstChild);
  }

  // ─── 9a. BUY-X-GET-Y BUNDLE INSTALLMENT HINT ────────────────────────────
  // HaloThemes ships with an "er-buyx-gety" bundle widget on PDPs. Each BUY
  // card carries data-current-id + data-variants (full JSON) + data-er-quantity
  // → we can compute the exact line price without parsing the DOM text.
  function enhanceBundleCards() {
    const buyCards = document.querySelectorAll('.er-buyx-gety__pr-item-buy');
    let syncedUnitCents = null;
    buyCards.forEach(card => {
      try {
        const variantsJson = card.getAttribute('data-variants');
        const sel = card.querySelector('select[name="er-buyx-gety__select"]');
        const currentId = (sel && sel.value) || card.getAttribute('data-current-id');
        const qty = parseInt(card.getAttribute('data-er-quantity') || '1', 10);
        if (!variantsJson || !currentId) return;
        const variants = JSON.parse(variantsJson);
        const variant = variants.find(v => String(v.id) === String(currentId)) || variants[0];
        if (!variant) return;
        if (syncedUnitCents === null) syncedUnitCents = variant.price || 0;

        // Remove any installment hint previously injected — user requested removal
        card.querySelectorAll('[data-sh-bundle-inst]').forEach(n => n.remove());
        return; // skip injection — bundle card stays clean without inline installment

        const tier = getTier(baht);
        const el = document.createElement('div');
        el.className = 'sh-line-inst sh-line-inst--bundle';
        el.setAttribute('data-sh-bundle-inst', '');

        if (tier.months > 0) {
          const perMonth = monthlyCost(baht, tier.months);
          el.innerHTML = `
            <span class="sh-line-inst__badge">0%</span>
            <span class="sh-line-inst__text">
              <span class="sh-line-inst__hero">${fmtTHB(perMonth)}</span><span class="sh-line-inst__per">${T.linePer}</span>
              <span class="sh-line-inst__sub">${T.lineSub(tier.months)}</span>
            </span>
          `;
        } else {
          const gap = fmtTHB(3000 - baht);
          el.classList.add('sh-line-inst--unavail');
          el.innerHTML = `
            <span class="sh-line-inst__badge sh-line-inst__badge--muted">i</span>
            <span class="sh-line-inst__text">
              <span class="sh-line-inst__sub">${T.bundleUnavailSub(gap)}</span>
            </span>
          `;
        }
        el.addEventListener('click', (e) => { e.stopPropagation(); openModal(); });

        // Insert right after the "Total:" row
        const totalRow = card.querySelector('.er-pr-item__price-total');
        if (totalRow && totalRow.parentNode) {
          totalRow.parentNode.insertBefore(el, totalRow.nextSibling);
        } else {
          card.appendChild(el);
        }
      } catch (_) { /* ignore malformed card */ }
    });

    // Sync PDP badge + sticky ribbon + sticky bar to the bundle's selected variant
    if (syncedUnitCents !== null) {
      currentPriceCents = syncedUnitCents;
      updatePdpBadge();
      updateRibbon();
      updatePdpStickyBar();
    }
  }

  function observeBundleCards() {
    // Attribute observer: card re-writes data-current-id when user picks a variant
    const cards = document.querySelectorAll('.er-buyx-gety__pr-item-buy');
    if (!cards.length) return false;

    let rafPending = false;
    const schedule = () => {
      if (rafPending) return;
      rafPending = true;
      requestAnimationFrame(() => {
        rafPending = false;
        enhanceBundleCards();
      });
    };

    cards.forEach(card => {
      // Observer #1 — react to the widget rewriting the Total: price cell.
      // We ignore mutations caused by our own injected hint element.
      const priceTotal = card.querySelector('.er-pr-item__price-total');
      if (priceTotal) {
        const mo = new MutationObserver(schedule);
        mo.observe(priceTotal, { childList: true, subtree: true, characterData: true });
      }
      // Observer #2 — data-current-id / data-er-quantity on the card itself.
      const moAttr = new MutationObserver(schedule);
      moAttr.observe(card, {
        attributes: true,
        attributeFilter: ['data-current-id', 'data-er-quantity'],
      });
    });

    // Direct listeners on the select element — cover both `change` and
    // `input` events since some widgets suppress one or the other.
    ['change', 'input'].forEach(evt => {
      document.addEventListener(evt, (e) => {
        if (e.target && e.target.matches && e.target.matches('select[name="er-buyx-gety__select"]')) {
          setTimeout(schedule, 30);
          setTimeout(schedule, 200); // second tick in case the widget reverts briefly
        }
      });
    });

    // Initial render
    enhanceBundleCards();
    return true;
  }

  // ─── 9b. CART LINE-ITEM INSTALLMENT HINT ─────────────────────────────────
  // Injects a small "ผ่อน X เดือน • ฿Y/เดือน" line under each cart line-item card.
  // Uses /cart.js as source of truth for line prices, then locates the matching
  // card in the DOM (cart drawer OR /cart page) via several selector fallbacks.
  function findLineCard(item) {
    const selectors = [
      `[data-line-item-key="${item.key}"]`,
      `[data-cart-item-key="${item.key}"]`,
      `[data-line-key="${item.key}"]`,
      `[data-key="${item.key}"]`,
      `[data-cart-item="${item.key}"]`,
      `[data-variant-id="${item.variant_id}"]`,
      `[data-variant="${item.variant_id}"]`,
      `a[href*="variant=${item.variant_id}"]`,
    ];
    for (const sel of selectors) {
      const el = document.querySelector(sel);
      if (el) return el.closest('.hdt-cart-item, .cart-item, [class*="cart-item"], [class*="line-item"], li, tr, .hdt-minicart-item') || el;
    }
    return null;
  }

  function injectLineInstallment(card, item) {
    if (!card) return;
    // line_price is in cents and represents price × quantity for that line
    const baht = (item.line_price || item.final_line_price || 0) / 100;
    // Skip free items (gifts, BOGO free legs, ฿0 promos) — no installment
    if (baht <= 0) return;
    const tier = getTier(baht);
    const perMonth = tier.months > 0 ? monthlyCost(baht, tier.months) : 0;
    const signature = `${tier.months}|${perMonth}`;
    const keyAttr = item.key || '';

    // Dedup globally via key (hint is now a sibling of the card, not a child).
    const existing = keyAttr
      ? document.querySelector(`[data-sh-line-inst][data-sh-item-key="${keyAttr.replace(/"/g, '\\"')}"]`)
      : null;
    if (existing && existing.dataset.shSignature === signature) {
      // Content unchanged — but ensure it's still positioned right after the card
      if (existing.previousElementSibling !== card) {
        card.parentNode.insertBefore(existing, card.nextSibling);
      }
      return;
    }
    if (existing) existing.remove();

    const wrap = document.createElement('div');
    wrap.className = 'sh-line-inst-row';
    wrap.setAttribute('data-sh-line-inst', '');
    wrap.dataset.shSignature = signature;
    wrap.dataset.shItemKey = keyAttr;

    const el = document.createElement('div');
    el.className = 'sh-line-inst sh-line-inst--cart';

    if (tier.months > 0) {
      el.innerHTML = `
        <span class="sh-line-inst__badge">0%</span>
        <span class="sh-line-inst__text">
          <span class="sh-line-inst__hero">${fmtTHB(perMonth)}</span><span class="sh-line-inst__per">${T.linePer}</span>
          <span class="sh-line-inst__sub">${T.lineSub(tier.months)}</span>
        </span>
      `;
    } else {
      el.classList.add('sh-line-inst--unavail');
      el.innerHTML = `
        <span class="sh-line-inst__badge sh-line-inst__badge--muted">i</span>
        <span class="sh-line-inst__text"><span class="sh-line-inst__sub">${T.lineNoInst}</span></span>
      `;
    }
    el.addEventListener('click', (e) => { e.stopPropagation(); openModal(); });
    wrap.appendChild(el);

    // Insert the hint as a SIBLING right after the line item — appending it
    // INSIDE the card was covering the theme's absolutely-positioned qty/
    // remove buttons (they sit at the bottom of the line item and our hint
    // stretched to fill the flex row). As a sibling, the hint is in its own
    // row and the theme's internal layout stays untouched.
    if (card.parentNode) {
      card.parentNode.insertBefore(wrap, card.nextSibling);
    }
  }

  // ─── Cart-total installment summary (cart drawer + /cart page) ─────────
  // Injects a prominent "ผ่อน 0% สูงสุด N เดือน · เพียง ฿X/เดือน" block next to
  // the subtotal so customers see the installment BEFORE they tap Checkout.
  function findSubtotalAnchors() {
    const found = [];
    // 2026-08-02 fix: never anchor inside the custom cart drawer (.sh-cart-drawer).
    // Its subtotal row is a compact single line (~194px) — the wide installment
    // card injected there covered the "Subtotal / ยอดรวม" label and the total
    // price (reported by Boss on /cart, reproduced on BOTH en and th).
    // The drawer already renders its own installment line (.sh-cart-drawer__inst),
    // so the injected card there was a duplicate. Cart PAGE anchors still work.
    const inCartDrawer = (n) => !!(n && n.closest && n.closest('.sh-cart-drawer'));
    const push = (n) => { if (n && !inCartDrawer(n) && !found.includes(n)) found.push(n); };

    // Strategy 1: well-known selectors across HaloThemes + common Shopify themes
    const sels = [
      '.hdt-cart-drawer__subtotal', '.cart-drawer__footer-subtotal',
      '[class*="cart-drawer"] [class*="subtotal"]',
      '.hdt-minicart__subtotal', '.cart__subtotal', '.totals__subtotal',
      '#main-cart-footer [class*="total"]', '.cart-footer__total',
      '[data-cart-subtotal]', 'cart-drawer [class*="totals"]',
    ];
    sels.forEach(sel => { try { document.querySelectorAll(sel).forEach(push); } catch(_){} });

    // Strategy 2: scan ALL text nodes for "รวมย่อย" / "ยอดรวม" / "Subtotal"
    if (!found.length) {
      const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
      let node;
      while ((node = walker.nextNode())) {
        const t = (node.textContent || '').trim();
        if (/รวมย่อย|ยอดรวม|^Subtotal$/i.test(t)) {
          const row = node.parentElement?.closest('tr, li, div, p, section, span')
                   || node.parentElement;
          push(row);
        }
      }
    }

    // Strategy 3: find checkout button and insert before its parent container
    if (!found.length) {
      const checkoutBtns = document.querySelectorAll(
        'button[name="checkout"], input[name="checkout"], a[href*="/checkout"], ' +
        '[class*="checkout-btn"], [class*="cart__checkout"], [class*="cart-drawer"] button'
      );
      checkoutBtns.forEach(btn => {
        const container = btn.closest('div, form, footer, section');
        if (container) push(container);
      });
    }

    return found;
  }

  function injectCartSummary(anchor, totalCents, signature) {
    // Avoid duplicates — check parent AND document
    if (!anchor || document.querySelector('[data-sh-cart-summary]')) return;
    const baht = (totalCents || 0) / 100;
    const tier = getTier(baht);

    /* If anchor parent is too narrow (< 200px), walk up to find a wider one
       so card logos don't get squished off-screen on cart page sidebar. */
    let injectAnchor = anchor;
    let scanCheck = anchor;
    for (let i = 0; i < 4 && scanCheck; i++) {
      const w = scanCheck.getBoundingClientRect().width;
      if (w >= 240) { injectAnchor = scanCheck; break; }
      scanCheck = scanCheck.parentElement;
    }

    const el = document.createElement('div');
    el.className = 'sh-cart-inst-summary';
    el.setAttribute('data-sh-cart-summary', '');
    if (signature) el.dataset.shSignature = signature;

    // Same premium navy-hero card as the PDP badge — keeps the visual
    // language consistent across product page and cart drawer.
    const cardIconSvg = `
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <rect x="2" y="5" width="20" height="14" rx="2"/>
        <line x1="2" y1="10" x2="22" y2="10"/>
        <line x1="6" y1="15" x2="10" y2="15"/>
      </svg>
    `;
    const chevronSvg = `
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="9 18 15 12 9 6"/>
      </svg>
    `;
    const cardsRow = `
      <span class="sh-cart-inst-summary__cards" aria-hidden="true">
        <span class="sh-cart-inst-summary__card">${CARD_LOGOS.visa}</span>
        <span class="sh-cart-inst-summary__card">${CARD_LOGOS.mastercard}</span>
        <span class="sh-cart-inst-summary__card">${CARD_LOGOS.jcb}</span>
        <span class="sh-cart-inst-summary__card">${CARD_LOGOS.amex}</span>
      </span>
    `;
    if (tier.months > 0) {
      const perMonth = monthlyCost(baht, tier.months);
      const labelTxt = LOCALE === 'th' ? 'ผ่อน 0%' : '0% INSTALLMENT';
      const perTxt = LOCALE === 'th' ? '/เดือน' : '/mo';
      const subTxt = LOCALE === 'th'
        ? `นาน ${tier.months} เดือน · เลือกได้ที่หน้าชำระเงิน`
        : `For ${tier.months} months · Choose at checkout`;
      el.innerHTML = `
        <div class="sh-cart-inst-summary__icon" aria-hidden="true">${cardIconSvg}</div>
        <div class="sh-cart-inst-summary__body">
          <span class="sh-cart-inst-summary__label">${labelTxt}</span>
          <span class="sh-cart-inst-summary__hero">
            <span class="sh-cart-inst-summary__amount">${fmtTHB(perMonth)}</span><span class="sh-cart-inst-summary__per">${perTxt}</span>
          </span>
          <span class="sh-cart-inst-summary__subline">
            <span class="sh-cart-inst-summary__sub">${subTxt}</span>
            ${cardsRow}
          </span>
        </div>
        <div class="sh-cart-inst-summary__chevron" aria-hidden="true">${chevronSvg}</div>
      `;
    } else {
      const gapBaht = Math.max(1, 3000 - baht);
      const labelTxt = LOCALE === 'th' ? 'ผ่อน 0% · ปลดล็อกได้!' : 'UNLOCK 0% INSTALLMENT';
      const heroSub = LOCALE === 'th' ? 'เพื่อรับสิทธิ์' : 'to unlock';
      const subTxt = LOCALE === 'th'
        ? `เพิ่มสินค้าให้ยอดรวมครบ ฿3,000 รับสิทธิ์ผ่อน 0% นาน 4 เดือน`
        : `Reach ฿3,000 cart total to unlock 0% installment for 4 months`;
      el.classList.add('sh-cart-inst-summary--rescue');
      el.innerHTML = `
        <div class="sh-cart-inst-summary__icon" aria-hidden="true">${cardIconSvg}</div>
        <div class="sh-cart-inst-summary__body">
          <span class="sh-cart-inst-summary__label">${labelTxt}</span>
          <span class="sh-cart-inst-summary__hero">
            <span class="sh-cart-inst-summary__amount">+${fmtTHB(gapBaht)}</span><span class="sh-cart-inst-summary__per">${heroSub}</span>
          </span>
          <span class="sh-cart-inst-summary__subline">
            <span class="sh-cart-inst-summary__sub">${subTxt}</span>
            ${cardsRow}
          </span>
        </div>
        <div class="sh-cart-inst-summary__chevron" aria-hidden="true">${chevronSvg}</div>
      `;
    }
    el.addEventListener('click', (e) => { e.stopPropagation(); openModal(); });

    /* If anchor is too narrow, insert into the wider parent we found */
    if (injectAnchor !== anchor && injectAnchor.contains(anchor)) {
      injectAnchor.insertBefore(el, anchor.parentNode === injectAnchor ? anchor : injectAnchor.firstChild);
    } else {
      anchor.parentNode.insertBefore(el, anchor);
    }
  }

  function refreshCartSummary(totalCents) {
    const baht = (totalCents || 0) / 100;
    const tier = getTier(baht);
    const perMonth = tier.months > 0 ? monthlyCost(baht, tier.months) : 0;
    // Same idempotency trick as line items — only re-render when the numbers
    // change, otherwise the summary block flashes on every cart event.
    const signature = `${tier.months}|${perMonth}|${baht}`;
    const existing = document.querySelector('[data-sh-cart-summary]');
    if (existing && existing.dataset.shSignature === signature) return;
    document.querySelectorAll('[data-sh-cart-summary]').forEach(n => n.remove());
    const anchors = findSubtotalAnchors();
    anchors.forEach(a => injectCartSummary(a, totalCents, signature));
  }

  let lineRefreshPending = false;
  function refreshLineItems() {
    if (lineRefreshPending) return;
    lineRefreshPending = true;
    Promise.resolve().then(() => {
      lineRefreshPending = false;
      fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(r => r.ok ? r.json() : null)
        .then(cart => {
          if (!cart || !Array.isArray(cart.items)) return;
          // Mirror cart into module state so ribbon + buttons stay in sync.
          cartState.item_count = cart.item_count || 0;
          cartState.total_price = cart.total_price || 0;
          cartState.items = cart.items;
          applyCartStateClasses();
          updateRibbon();
          positionRibbon();

          // Per-line installment hints removed — the cart drawer + cart page
          // now show only a single "cart-total installment" block next to the
          // subtotal. Clean up any previously-injected line hints so nothing
          // is left behind after a reload or cart change.
          document.querySelectorAll('[data-sh-line-inst].sh-line-inst-row, .sh-line-inst--cart').forEach(n => {
            // Only remove cart-drawer / cart-page hints; keep bundle hints on PDP.
            if (n.closest && n.closest('.er-buyx-gety__pr-item-buy')) return;
            const row = n.closest('.sh-line-inst-row') || n;
            row.remove();
          });

          // Cart-total summary next to subtotal
          refreshCartSummary(cart.total_price);
        })
        .catch(() => {});
    });
  }

  function observeCartMutations() {
    // Watch for cart drawer opening or line items being re-rendered after qty change.
    // Debounced via rAF to avoid reacting to our own insertions.
    let rafPending = false;
    const schedule = () => {
      if (rafPending) return;
      rafPending = true;
      requestAnimationFrame(() => {
        rafPending = false;
        refreshLineItems();
      });
    };

    const mo = new MutationObserver((mutations) => {
      // Ignore mutations that were caused by our own injection
      for (const m of mutations) {
        for (const n of m.addedNodes) {
          if (n.nodeType !== 1) continue;
          if (n.matches && (n.matches('[data-sh-line-inst]') || n.closest?.('[data-sh-line-inst]'))) continue;
          const tag = (n.tagName || '').toLowerCase();
          const cls = (n.className && typeof n.className === 'string') ? n.className : '';
          if (
            /cart|line-item|minicart|drawer/i.test(cls) ||
            tag === 'hdt-cart-drawer' || tag === 'hdt-minicart' ||
            (n.querySelector && n.querySelector('[class*="cart"], [class*="line-item"]'))
          ) {
            schedule();
            return;
          }
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });

    // Also refresh on Shopify AJAX cart events (fired by most themes incl. HaloThemes)
    ['cart:updated', 'cart:refresh', 'cart:change', 'cart:build', 'on:cart:after-update'].forEach(evt => {
      document.addEventListener(evt, schedule);
    });

    // Patch fetch to catch cart mutations from theme JS
    const origFetch = window.fetch;
    if (origFetch && !origFetch.__shPatched) {
      window.fetch = function (...args) {
        const url = (typeof args[0] === 'string') ? args[0] : (args[0]?.url || '');
        const p = origFetch.apply(this, args);
        if (/\/cart\/(add|change|update|clear)/i.test(url)) {
          p.then(() => setTimeout(schedule, 150)).catch(() => {});
        }
        return p;
      };
      window.fetch.__shPatched = true;
    }
  }

  // ─── 10. OBSERVERS ───────────────────────────────────────────────────────
  function observeStickyATC() {
    // rAF debounce — prevents re-entrancy if our own DOM mutations fire the observer
    let rafPending = false;
    function scheduleUpdate() {
      if (rafPending) return;
      rafPending = true;
      requestAnimationFrame(() => {
        rafPending = false;
        updateRibbon();
        positionRibbon();
      });
    }

    // Observe only the hdt-sticky-btn-atc element itself (not the whole body).
    // The ribbon element is a different node, so our callbacks modifying
    // ribbon.style / ribbon.classList will NOT re-trigger this observer.
    function attachAtcObserver() {
      const atc = document.querySelector('hdt-sticky-btn-atc');
      if (!atc) return false;
      const atcObserver = new MutationObserver(scheduleUpdate);
      atcObserver.observe(atc, {
        attributes: true,
        attributeFilter: ['class', 'style'],
        childList: false,
        subtree: false,
      });
      return true;
    }

    // If hdt-sticky-btn-atc is already in DOM (common case — rendered by Liquid)
    if (attachAtcObserver()) return;

    // Rare case: ATC not yet in DOM.  Watch body for structural changes only
    // (childList: true, attributes: false) — our callbacks only mutate attributes,
    // so this bodyObserver will NOT be re-triggered by updateRibbon/positionRibbon.
    const bodyObserver = new MutationObserver(() => {
      if (attachAtcObserver()) {
        bodyObserver.disconnect();
        scheduleUpdate();
      }
    });
    bodyObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: false,
    });
  }

  /* Sync the er-buyx-gety bundle <select> to the variant ID currently chosen
     in the main variant picker. This way, when shopper picks a Bedding size
     at the top, the bundle below mirrors it AND readCurrentPrice() (which
     prioritizes the bundle) reflects the right price/installment. */
  function syncBundleToMainVariant(targetVariantId) {
    if (!targetVariantId) return;
    document.querySelectorAll('.er-buyx-gety__pr-item-buy').forEach(card => {
      const sel = card.querySelector('select[name="er-buyx-gety__select"]');
      if (!sel) return;
      const currentVal = String(sel.value || '');
      const newVal = String(targetVariantId);
      if (currentVal === newVal) return;
      /* Only set if the option exists in this select (variant must be in bundle) */
      const opt = Array.from(sel.options).find(o => String(o.value) === newVal);
      if (!opt) return;
      sel.value = newVal;
      /* Fire change so bundle widget recalculates its price/total */
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      sel.dispatchEvent(new Event('input', { bubbles: true }));
    });
  }

  /* Find the currently-selected variant ID from main picker (radio or select) */
  function readMainPickerVariantId() {
    /* Try checked radio in main product info column */
    const titleH1 = document.querySelector('h1.hdt-product__title, .hdt-product__title h1');
    const infoCol = titleH1
      ? titleH1.closest('.hdt-product-info__list, .hdt-product-info, .product__info, main') || document
      : document;
    /* Standard select for variant ID */
    const sel = infoCol.querySelector('form[action*="/cart/add"] select[name="id"], select[name="id"]');
    if (sel && sel.value) return sel.value;
    /* Hidden id input updated by HaloThemes web component */
    const idInput = infoCol.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (idInput && idInput.value) return idInput.value;
    return null;
  }

  /* F-55 (2026-04-28): Sync sticky ATC price + variant select from main picker.
     Halo's .hdt-money does NOT auto-propagate variant changes between main form
     and sticky form (2 separate <form> elements). Manually update sticky DOM from
     window.__SH_product variant data. Called from scheduleRefresh on every change. */
  function syncStickyPriceFromVariant(variantId) {
    if (!variantId || !window.__SH_product || !window.__SH_product.variants) return;
    const variant = window.__SH_product.variants.find(v => String(v.id) === String(variantId));
    if (!variant) return;
    const formatPrice = (satang) => Math.round(satang / 100).toLocaleString('th-TH') + ' ฿';
    const priceEl = document.querySelector('.hdt-sticky-btn-atc .hdt-sticky-atc__price-amount');
    if (priceEl) priceEl.textContent = formatPrice(variant.price);
    const priceWasEl = document.querySelector('.hdt-sticky-btn-atc .hdt-sticky-atc__price-was');
    if (priceWasEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceWasEl.textContent = formatPrice(variant.compare_at_price);
        priceWasEl.style.display = '';
      } else {
        priceWasEl.style.display = 'none';
      }
    }
    const stickySelect = document.querySelector('.hdt-sticky-btn-atc select[name="id"]');
    if (stickySelect && String(stickySelect.value) !== String(variantId)) {
      stickySelect.value = variantId;
    }
    /* F-58.9 (2026-04-28): Main→Modal sync — update modal radio + size pill text
       when variant changes via PDP picker. Without this, picking Bedding size in
       PDP wouldn't update the bottom sheet's selected state. */
    if (typeof syncV8UIToVariant === 'function') {
      syncV8UIToVariant(variantId);
    }
    /* F-58.22 (2026-04-29): Re-install icon guardian on every variant change
       (no-op if MutationObserver already attached). Guardian survives any future
       Halo-induced icon wipes via persistent observer (race-condition-proof). */
    if (typeof installShStickyIconGuardian === 'function') installShStickyIconGuardian();
  }

  /* F-58.22 (2026-04-29): Persistent SVG icon guardian via MutationObserver.
     Halo's <hdt-sticky-btn-atc> web component asynchronously rewrites button
     label innerHTML on variant changes, wiping non-Halo elements (our cart icon
     SVG). MutationObserver watches line1's children and re-injects icon on any
     childList mutation — race-condition-proof regardless of Halo's timing. */
  const SH_V12_ICON_SVG =
    '<svg class="sh-v12-primary__icon" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<circle cx="9" cy="20" r="1.5"/>' +
      '<circle cx="18" cy="20" r="1.5"/>' +
      '<path d="M3 4h2.5l2.4 11.4a2 2 0 0 0 2 1.6h8.8a2 2 0 0 0 2-1.5L23 8H6"/>' +
    '</svg>';

  function installShStickyIconGuardian() {
    /* F-58.23 (2026-04-29): Upgraded — observe at <hdt-sticky-btn-atc> root level
       with subtree:true. Previous F-58.22 attached observer to .sh-v12-primary__line1
       which Halo's web component REPLACES wholesale during variant change → observer
       attached to old (detached) element does nothing. Root-level + subtree catches
       mutations regardless of how deep Halo rewrites. Plus setInterval 250ms fallback
       for any corner case the observer misses. */
    const root = document.querySelector('hdt-sticky-btn-atc');
    if (!root) return false;
    const ensureIcon = () => {
      const line1 = root.querySelector('.sh-v12-primary__line1');
      if (!line1) return;
      if (!line1.querySelector('.sh-v12-primary__icon')) {
        line1.insertAdjacentHTML('afterbegin', SH_V12_ICON_SVG);
      }
    };
    ensureIcon();
    /* Idempotent: skip if observer + interval already attached */
    if (root.dataset.shIconGuard === '1') return true;
    root.dataset.shIconGuard = '1';
    const observer = new MutationObserver(ensureIcon);
    observer.observe(root, { childList: true, subtree: true });
    /* Belt-and-suspenders heartbeat — covers cases where observer doesn't fire
       (some browsers/edge cases). Cheap: querySelector is O(depth). */
    setInterval(ensureIcon, 250);
    return true;
  }

  /* F-49 (2026-04-27): Recompute installment text on Halo's sticky ATC
     after a variant change. .hdt-money auto-updates the price amount,
     but the installment subtitle is custom — read new price, rewrite text.
     F-53-ROLLBACK: restored " · ส่งฟรี" suffix per San.
     Format: "ผ่อน 315 ฿/เดือน · ส่งฟรี" — matches Shopify TH money format
     (number + space + ฿ suffix) so it doesn't reflow on variant change.
     Sync trigger: listenVariantChange() debounced 300ms — UNCHANGED. */
  function updateStickyInstallment() {
    const priceEl = document.querySelector('.hdt-sticky-btn-atc .hdt-sticky-atc__price-amount');
    /* F-58.10 (2026-04-29) FORCE-RE-PUSH-2150: selector broadened — V12 moved
       data-sh-price-monthly from .hdt-sticky-atc__price-sub (old) to
       .sh-v12-primary__line2 (new). Attribute-only selector future-proof. */
    const subEl = document.querySelector('.hdt-sticky-btn-atc [data-sh-price-monthly]');
    if (!priceEl || !subEl) return;
    const priceText = (priceEl.textContent || '').replace(/[^\d]/g, '');
    const priceNum = parseInt(priceText, 10);
    if (!priceNum || isNaN(priceNum)) return;
    const monthly = Math.round(priceNum / 10);
    /* F-66 (2026-04-30): locale-aware. Liquid `| t` rendered correct text on
       initial load, but this function overwrites textContent on variant change.
       Detect locale + use matching template (mirrors locale key values). */
    const htmlLang = (document.documentElement.lang || 'th').toLowerCase();
    const isEn = htmlLang.indexOf('en') === 0;
    const formatted = monthly.toLocaleString(isEn ? 'en-US' : 'th-TH');
    subEl.textContent = isEn
      ? '0% interest · ฿' + formatted + '/month'
      : 'ผ่อน 0% · ฿' + formatted + '/ เดือน';
  }

  /* F-56 (2026-04-28): V8 size picker bottom sheet modal.
     Replaces native <select> dropdown with a native-app-feeling sheet.
     Tapping a modal item sets sticky select.value + dispatches change event →
     listenVariantChange (F-55.1) catches it → syncStickyPriceFromVariant runs
     → price/strikethrough/monthly/size pill all sync. Modal selected state +
     size pill text update via syncV8UIToVariant on every sticky select change. */
  /* F-64 (2026-04-30): Subtitles — Option C (specs + positioning).
     F-66: Locale-aware via <html lang>.
     F-68 (2026-04-30): SKU-based dimension extraction — replaced hardcoded
     size map (which had Queen=152 incorrectly; actual SleepHappy SKU = 153).
     Width now extracted from SKU pattern `...{W}X{L}X{T}...` per-variant →
     accurate for all product lines (Hotel Ecstasy 30cm thick, Atlantis 28cm,
     Element 24cm, 10-inch line 26cm with 105/150/180 widths, etc.).
     Fallback to capacity-only subtitle if SKU has no dimension pattern. */

  /* Capacity + positioning rules by Thai size (locale-aware label) */
  const SH_V8_CAPACITY = {
    '3':   { count: 1, posTh: '',           posEn: '' },
    '3.5': { count: 1, posTh: '',           posEn: '' },
    '4':   { count: 1, posTh: '',           posEn: '' },
    '5':   { count: 2, posTh: 'มาตรฐาน',     posEn: 'standard' },
    '6':   { count: 2, posTh: 'กว้างพิเศษ',   posEn: 'extra wide' }
  };

  function extractWidthFromSku(sku) {
    if (!sku) return null;
    /* Pattern: e.g. SHRM5THESPAIS00153X198X30PW → captures 153 */
    const m = sku.match(/(\d{2,3})X(\d{2,3})X(\d{2,3})/i);
    return m ? parseInt(m[1], 10) : null;
  }

  /* F-68.2 (2026-04-30): Extract width from product description for the
     current variant size. Description is source of truth (customer-facing
     content). Audit found description-vs-SKU mismatch on some products
     (Hotel 10-inch shows 105/150/180 in description but SKU encodes
     107/153/183 — different rounding/spec generations). Description wins.
     Patterns supported (mixed locale + format):
       "3.5 feet, size 105×198×26"
       "Dimensions: 6 feet (183x198x30 cm)"
       "3.5 ฟุต ขนาด 107×198×30"
       "5 ฟุต (150×198×26)"
     Returns null if no match → caller falls back to SKU width. */
  function extractWidthFromDescription(desc, sizeKey) {
    if (!desc || !sizeKey) return null;
    const escapedKey = sizeKey.replace('.', '\\.');
    /* size + ฟุต/feet/ft + (any chars up to 50, non-greedy) + (\d{2,3}) followed by × × × pattern */
    const re = new RegExp(
      '\\b' + escapedKey + '\\s*(?:feet|ฟุต|ft)\\b[^\\d\\n]{0,50}?(\\d{2,3})[xX×]\\s*\\d{2,3}[xX×]\\s*\\d{1,3}',
      'i'
    );
    const m = desc.match(re);
    return m ? parseInt(m[1], 10) : null;
  }

  function getV8Subtitle(title, sku, desc) {
    if (!title) return '';
    /* Extract Thai-foot size key — F-68.1 (2026-04-30) bug fix:
       Previous regex `^(\d+)\s` matched FIRST number, which broke for variants
       like "4 นิ้ว / 5 ฟุต (Queen)" → matched "4" (thickness) instead of "5" (size).
       Now anchored to the number IMMEDIATELY BEFORE "ฟุต"/"feet"/"ft". */
    const match = title.match(/(\d+(?:\.\d+)?)\s*(?:ฟุต|feet|ft\b)/i);
    if (!match) return '';
    const sizeKey = match[1];
    const cap = SH_V8_CAPACITY[sizeKey];
    if (!cap) return '';
    /* Locale */
    const htmlLang = (document.documentElement.lang || 'th').toLowerCase();
    const isEn = htmlLang.indexOf('en') === 0;
    /* Width source-of-truth chain (F-68.2):
       1. Product description (customer-facing — most accurate per-product)
       2. SKU encoding (fallback — factory-truth, may differ from description)
       3. null → no width shown */
    const widthCm = extractWidthFromDescription(desc, sizeKey) || extractWidthFromSku(sku);
    /* Build subtitle */
    if (isEn) {
      let parts = [];
      if (widthCm) parts.push(widthCm + ' cm wide');
      let cap_label = 'Sleeps ' + cap.count;
      if (cap.posEn) cap_label += ' (' + cap.posEn + ')';
      parts.push(cap_label);
      return parts.join(' · ');
    } else {
      let parts = [];
      if (widthCm) parts.push('กว้าง ' + widthCm + ' ซม.');
      let cap_label = 'นอน ' + cap.count + ' ท่าน';
      if (cap.posTh) cap_label += ' (' + cap.posTh + ')';
      parts.push(cap_label);
      return parts.join(' · ');
    }
  }

  /* F-68 (2026-04-30): Normalize variant title capitalization.
     Shopify admin language editor sometimes has inconsistent EN translations:
     "(TWIN)", "(Queen)", "(KING)" mixed within same product. Normalize to
     Title Case at display time: (TWIN) → (Twin), (KING) → (King). */
  function normalizeVariantTitle(title) {
    if (!title) return '';
    return title.replace(/\(([A-Z]{2,})\)/g, function (_, word) {
      return '(' + word.charAt(0) + word.slice(1).toLowerCase() + ')';
    });
  }

  function syncV8UIToVariant(variantId) {
    if (!variantId) return;
    /* Update modal selected state */
    document.querySelectorAll('[data-sh-modal-item]').forEach(i => {
      const isMatch = i.getAttribute('data-variant-id') === String(variantId);
      i.classList.toggle('is-selected', isMatch);
      i.setAttribute('aria-selected', isMatch ? 'true' : 'false');
    });
    /* Update size pill text from variant title — F-68: normalize capitalization */
    const sizePillValue = document.querySelector('[data-sh-current-size]');
    if (sizePillValue && window.__SH_product && window.__SH_product.variants) {
      const variant = window.__SH_product.variants.find(v => String(v.id) === String(variantId));
      if (variant && variant.title) sizePillValue.textContent = normalizeVariantTitle(variant.title);
    }
  }

  function initV8Modal() {
    const modal = document.querySelector('[data-sh-modal]');
    if (!modal) return;

    /* Apply subtitles + normalize title capitalization on each modal item.
       F-68: pass SKU + description to getV8Subtitle for accurate per-variant width.
       F-68.2: description on modal (data-sh-product-desc) used as primary source;
       SKU used as fallback. */
    const productDesc = modal.getAttribute('data-sh-product-desc') || '';
    modal.querySelectorAll('[data-sh-modal-item]').forEach(item => {
      const titleEl = item.querySelector('.sh-v8-modal__title-line');
      const subtitleEl = item.querySelector('[data-sh-subtitle]');
      const variantTitle = (item.getAttribute('data-variant-title') || (titleEl && titleEl.textContent) || '').trim();
      const variantSku = item.getAttribute('data-variant-sku') || '';
      /* Normalize displayed title — fixes (TWIN)/(KING) admin-translation inconsistency */
      if (titleEl) titleEl.textContent = normalizeVariantTitle(variantTitle);
      if (subtitleEl) subtitleEl.textContent = getV8Subtitle(variantTitle, variantSku, productDesc);
    });

    /* Also normalize size pill initial value (Liquid renders raw variant.title) */
    const sizePillValue = document.querySelector('[data-sh-current-size]');
    if (sizePillValue) sizePillValue.textContent = normalizeVariantTitle(sizePillValue.textContent.trim());

    /* Open modal — tap size pill */
    const sizePill = document.querySelector('[data-sh-open-modal]');
    if (sizePill) {
      sizePill.addEventListener('click', (e) => {
        e.preventDefault();
        modal.removeAttribute('hidden');
        /* requestAnimationFrame ensures hidden→display:block before transition */
        requestAnimationFrame(() => {
          requestAnimationFrame(() => modal.classList.add('is-open'));
        });
        document.body.style.overflow = 'hidden';
      });
    }

    /* Close modal */
    const closeModal = () => {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(() => modal.setAttribute('hidden', ''), 250);
    };
    modal.querySelectorAll('[data-sh-modal-close]').forEach(el => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        closeModal();
      });
    });

    /* Item click — select variant via sticky select change event */
    modal.querySelectorAll('[data-sh-modal-item]').forEach(item => {
      const handleSelect = () => {
        if (item.classList.contains('is-unavailable')) return;
        const variantId = item.getAttribute('data-variant-id');
        if (!variantId) return;
        /* F-58.9 (2026-04-28): Sticky→Main sync — update PDP "Bedding size" picker.
           Find variant from __SH_product, then update main picker radio (Halo
           uses radio inputs with name="Bedding size" etc.) + main form select. */
        const variant = window.__SH_product && window.__SH_product.variants
          ? window.__SH_product.variants.find(v => String(v.id) === String(variantId))
          : null;
        const titleH1 = document.querySelector('h1.hdt-product__title, .hdt-product__title h1');
        const mainCol = titleH1
          ? titleH1.closest('.hdt-product-info__list, .hdt-product-info, .product__info, main') || document
          : document;
        if (variant && window.__SH_product && window.__SH_product.options) {
          /* Update each option radio (option1 = Bedding size, option2 = Color, etc.) */
          window.__SH_product.options.forEach((optionName, idx) => {
            const optionValue = variant['option' + (idx + 1)];
            if (!optionName || !optionValue) return;
            const radios = mainCol.querySelectorAll('input[type="radio"][name="' + CSS.escape(optionName) + '"]');
            radios.forEach(r => {
              if (r.value === optionValue && !r.checked) {
                r.checked = true;
                r.dispatchEvent(new Event('change', { bubbles: true }));
              }
            });
          });
        }
        /* Update main form's hidden variant ID input + select */
        const mainSel = mainCol.querySelector('form[action*="/cart/add"] select[name="id"]');
        if (mainSel && !mainSel.closest('.hdt-sticky-btn-atc') && mainSel.value !== variantId) {
          mainSel.value = variantId;
          mainSel.dispatchEvent(new Event('change', { bubbles: true }));
        }
        const mainIdInput = mainCol.querySelector('form[action*="/cart/add"] input[name="id"]');
        if (mainIdInput && !mainIdInput.closest('.hdt-sticky-btn-atc') && mainIdInput.value !== variantId) {
          mainIdInput.value = variantId;
        }
        /* Update URL ?variant= so refreshing/sharing preserves selection */
        try {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variantId);
          window.history.replaceState({}, '', url.toString());
        } catch (e) { /* no-op if URL API unsupported */ }
        /* Update sticky select.value + dispatch change → F-55.1 takes over */
        const stickySelect = document.querySelector('.hdt-sticky-btn-atc select[name="id"]');
        if (stickySelect) {
          stickySelect.value = variantId;
          stickySelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
        /* Immediate UI feedback (selected state) before close */
        modal.querySelectorAll('[data-sh-modal-item]').forEach(i => {
          i.classList.toggle('is-selected', i === item);
          i.setAttribute('aria-selected', i === item ? 'true' : 'false');
        });
        /* Update size pill text immediately too (before sync runs) */
        const sizePillValue = document.querySelector('[data-sh-current-size]');
        const titleLine = item.querySelector('.sh-v8-modal__title-line');
        if (sizePillValue && titleLine) sizePillValue.textContent = titleLine.textContent.trim();
        /* Close with slight delay so user sees selection */
        setTimeout(closeModal, 180);
      };
      item.addEventListener('click', handleSelect);
      item.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleSelect();
        }
      });
    });

    /* Listen for sticky select changes (e.g., from main page picker) →
       sync modal selected state + size pill text */
    const stickySelect = document.querySelector('.hdt-sticky-btn-atc select[name="id"]');
    if (stickySelect) {
      stickySelect.addEventListener('change', () => syncV8UIToVariant(stickySelect.value));
    }

    /* Escape key to close */
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });
  }

  function listenVariantChange() {
    /* F-55.1 (2026-04-28): scheduleRefresh accepts optional explicitVariantId.
       Race condition fix: when user changes STICKY's variant select directly,
       readMainPickerVariantId() returns STALE main form ID — sticky price
       wouldn't update visibly. Now if change came from sticky select, caller
       passes its value explicitly so sync uses correct ID. */
    const scheduleRefresh = (explicitVariantId) => {
      setTimeout(() => {
        /* Priority: explicit ID (e.g. from sticky select event) > main picker.
           Sync bundle BEFORE reading price so readCurrentPrice (which checks
           the bundle first) gets the right variant. */
        const mainId = explicitVariantId || readMainPickerVariantId();
        if (mainId) {
          syncBundleToMainVariant(mainId);
          syncStickyPriceFromVariant(mainId); /* F-55 (2026-04-28): sync sticky price */
        }
        readCurrentPrice();
        applyCartStateClasses();
        updateRibbon();
        updatePdpBadge();
        updatePdpStickyBar();
        updateStickyInstallment();
        const modal = document.getElementById('sh-inst-modal');
        if (modal && modal.classList.contains('is-open')) renderModal();
      }, 300);
    };

    document.addEventListener('change', (e) => {
      const t = e.target;
      /* F-55.1 (2026-04-28): STICKY's own variant select — pass its NEW value
         directly. Bypasses readMainPickerVariantId() which would return STALE
         main form ID (Halo doesn't propagate sticky→main automatically). */
      if (t.matches('.hdt-sticky-btn-atc select[name="id"]')) {
        scheduleRefresh(t.value);
        return;
      }
      // Explicit variant/option selectors (main picker)
      if (t.matches('select[name="id"], input[name="id"], [name*="option"], [name*="Option"]')) {
        scheduleRefresh();
        return;
      }
      // HaloThemes uses radio inputs with the OPTION NAME as the attribute
      // (name="Bedding size", name="Color", etc.) — there's no "option" or
      // "id" in the attribute. Catch any radio/checkbox inside a variant
      // picker / product form so we don't miss variant swaps.
      if ((t.tagName === 'INPUT') && (t.type === 'radio' || t.type === 'checkbox') &&
          t.closest('[class*="variant-picker"], fieldset, .product-form, [class*="swatch"], [data-option], .product__info')) {
        scheduleRefresh();
        return;
      }
      // Quantity changes
      if (t.matches('[name="quantity"], .quantity__input, input[type="number"]')) {
        scheduleRefresh();
      }
    });

    // Quantity +/- buttons (input events)
    document.addEventListener('input', (e) => {
      if (e.target.matches('[name="quantity"], .quantity__input')) {
        scheduleRefresh();
      }
    });

    // Quantity +/- button clicks
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.quantity__button, [class*="qty-btn"], [class*="quantity-"] button, .js-qty-btn');
      if (btn) {
        setTimeout(scheduleRefresh, 100);
      }
    });

    // Safety nets — themes that swap variants via web components / custom
    // elements often DON'T fire change events on the inner radios. Watch
    // the price container AND the variant-picker web component for
    // attribute/DOM mutations, then refresh.
    const priceContainerSelectors = [
      '.hdt-product__price',               // HaloThemes primary
      '.hdt-price-wrapp',                   // HaloThemes wrapper
      '.hdt-product-info__item.hdt-product__price',
      'hdt-price',                          // web component
      '[class*="product__info"] .price',
      '.product__info .price',
      '.product-form__info .price',
      'main .price--large',
      'main [class*="price__container"]',
      '.product__price',
    ];
    const priceContainers = [];
    priceContainerSelectors.forEach(sel => {
      try { document.querySelectorAll(sel).forEach(el => { if (!priceContainers.includes(el)) priceContainers.push(el); }); } catch(_) {}
    });

    let priceRaf = false;
    const scheduleOnMutation = () => {
      if (priceRaf) return;
      priceRaf = true;
      requestAnimationFrame(() => {
        priceRaf = false;
        scheduleRefresh();
      });
    };

    priceContainers.forEach(el => {
      const obs = new MutationObserver(scheduleOnMutation);
      obs.observe(el, { childList: true, subtree: true, characterData: true });
    });

    // Watch HaloThemes web-component variant pickers — they update their
    // `selected-variant` attribute when the user picks a swatch, often
    // without firing standard change events we can catch.
    document.querySelectorAll('hdt-variant-picker, variant-radios, variant-selects').forEach(picker => {
      const obs = new MutationObserver(scheduleOnMutation);
      obs.observe(picker, { attributes: true, attributeFilter: ['selected-variant', 'data-current-variant', 'value'], childList: true, subtree: true });
    });

    // Catch-all: any click inside the variant-picker area kicks a refresh.
    // Covers themes that intercept clicks on styled buttons/labels and
    // update radios programmatically without bubbling a change event.
    document.addEventListener('click', (e) => {
      if (e.target.closest('[class*="variant-picker"], hdt-variant-picker, [class*="swatch"], [class*="product-form__input"], fieldset[data-index], [class*="product-form__values"], [class*="product__variant"]')) {
        // Small delay to let theme JS finish its own update first
        setTimeout(scheduleRefresh, 200);
      }
    });

    // ULTIMATE SAFETY NET — poll every 1s for variant ID / price text /
    // qty changes. Cheap (a few DOM reads) and guarantees the badge stays
    // in sync regardless of HOW the theme updates the page (web-component
    // attribute, AJAX, popstate, custom events we don't know about, etc.).
    let lastSig = '';
    setInterval(() => {
      const idEls = [...document.querySelectorAll('form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]')];
      const liveId = (idEls.find(el => el.value && el.value.trim()) || idEls[0])?.value || '';
      const priceText = (document.querySelector('.hdt-product__price, [class*="product__info"] .price, .price--large')?.textContent || '').replace(/\s+/g, '');
      const qty = readCurrentQuantity();
      const variantParam = new URLSearchParams(location.search).get('variant') || '';
      const sig = `${liveId}|${priceText}|${qty}|${variantParam}`;
      if (sig !== lastSig) {
        lastSig = sig;
        scheduleRefresh();
      }
    }, 1000);
  }

  // ─── 10a. CART-SHORTCUT FAB (non-PDP / non-cart pages) ─────────────────
  // On content/browse pages we hide the full installment ribbon to keep the
  // viewport clean and avoid pressuring shoppers before they've decided.
  // A minimal floating "Shopping Cart" link stays so mobile users never have
  // to hunt for the cart icon in the header.
  function buildCartFab() {
    if (document.getElementById('sh-cart-fab')) return;
    const fab = document.createElement('a');
    fab.id = 'sh-cart-fab';
    fab.className = 'sh-cart-fab';
    fab.href = '/cart';
    fab.setAttribute('aria-label', LOCALE === 'th' ? 'ตะกร้าสินค้า' : 'Shopping Cart');
    fab.innerHTML = `
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <circle cx="9" cy="21" r="1"/>
        <circle cx="20" cy="21" r="1"/>
        <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
      </svg>
      <span>${LOCALE === 'th' ? 'ตะกร้าสินค้า' : 'Shopping Cart'}</span>
    `;
    document.body.appendChild(fab);
  }

  // ─── 10b. CHECKOUT BUTTON NEXT TO THEME'S STICKY ATC ────────────────────
  // The theme renders <hdt-sticky-btn-atc> as a floating bar near the bottom
  // of the PDP with variant select + qty + ATC. We append a sibling Check out
  // button so customers can buy-now without the extra "view cart" hop.
  function injectCheckoutNextToStickyAtc() {
    // F-45.12 (2026-04-27): Re-enabled — checkout button appears after ATC click
    // (when body has .sh-cart-has-items class). Styled via CSS as full-width navy.
    const stickyATC = document.querySelector('hdt-sticky-btn-atc');
    if (!stickyATC) return false;
    if (stickyATC.querySelector('[data-sh-checkout-btn]')) return true;
    const atcBtn = stickyATC.querySelector(
      'button[name="add"], button[type="submit"], .product-form__submit, ' +
      '[class*="add-to-cart"], button[class*="atc"]'
    );
    if (!atcBtn) return false;
    const checkoutBtn = document.createElement('button');
    checkoutBtn.type = 'button';
    checkoutBtn.className = 'sh-sticky-atc-checkout';
    checkoutBtn.setAttribute('data-sh-checkout-btn', '');
    checkoutBtn.textContent = LOCALE === 'th' ? 'ชำระเงิน' : 'Check out';
    checkoutBtn.addEventListener('click', (e) => { e.stopPropagation(); goToCheckout(); });
    atcBtn.parentNode.insertBefore(checkoutBtn, atcBtn.nextSibling);
    return true;
  }

  // ─── 10d. PDP STICKY ATC BAR (custom — replaces theme's sticky) ─────────
  // Compact horizontal bar pinned to bottom of viewport on PDP only:
  //   thumb · title · price ·  [Add to cart]
  // After ATC click → POST /cart/add → bar transforms into:
  //   thumb · title · price ·  [Cart] [Checkout]
  function getPdpProductImageUrl() {
    // Try OpenGraph image first, fallback to first product gallery image
    const og = document.querySelector('meta[property="og:image"]');
    if (og && og.content) return og.content;
    const gallery = document.querySelector(
      '.hdt-product__media img, .product__media img, ' +
      '[class*="product-gallery"] img, .product-single__media img, main .product img'
    );
    if (gallery && gallery.src) return gallery.src;
    return '';
  }
  function getPdpProductTitle() {
    let raw = '';
    if (window.__SH_product && window.__SH_product.title) raw = window.__SH_product.title;
    else {
      const h = document.querySelector('.hdt-product__title, .product__title h1, h1.product-single__title, main h1');
      raw = h ? h.textContent.trim() : '';
    }
    if (!raw) return '';
    /* Smart short-title extraction: SleepHappy SEO titles are very long
       ("ที่นอนยางพารา...รุ่น Atlantis V2 Lite หนา 8 นิ้ว...Best Seller").
       Extract the model name after "รุ่น" or fall back to handle. */
    const m = raw.match(/รุ่น\s+([^\u0E00-\u0E7F]+?)(?:\s+(?:หนา|สี|ขนาด|รุ่น|\u0E2B\u0E19\u0E32))/);
    if (m && m[1] && m[1].length < 40) return m[1].trim();
    const m2 = raw.match(/รุ่น\s+([A-Za-z0-9\s.\-+]+)/);
    if (m2 && m2[1]) return m2[1].trim().slice(0, 32);
    /* Handle-derived fallback: "atlantis-v2-pro" → "Atlantis V2 Pro" */
    const handle = (window.__SH_product && window.__SH_product.handle) || (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
    if (handle) return handle.split('-').map(s => s.charAt(0).toUpperCase() + s.slice(1)).join(' ');
    return raw.slice(0, 40);
  }
  /* Read compare_at_price (Comp. Value) for current variant.
     PRIORITY: window.__SH_product variant data (always in sync with selection)
              > inline ProductJson > DOM scrape (last resort, can be stale). */
  function getCompareAtCents() {
    /* Priority 1: window.__SH_product (most reliable, set by snippet) */
    const p = window.__SH_product;
    if (p && p.variants && productVariantId) {
      const v = p.variants.find(x => String(x.id) === String(productVariantId));
      if (v && v.compare_at_price) return v.compare_at_price;
    }
    /* Priority 2: inline ProductJson */
    try {
      const json = document.querySelector('script[type="application/json"][data-product-json], script[type="application/json"][id*="ProductJson"]');
      if (json) {
        const data = JSON.parse(json.textContent);
        const variants = data.variants || (data.product && data.product.variants);
        if (variants && productVariantId) {
          const v = variants.find(x => String(x.id) === String(productVariantId));
          if (v && v.compare_at_price) return v.compare_at_price;
        }
      }
    } catch(_){}
    /* Priority 3: DOM scrape (last resort — may show stale variant) */
    const titleH1 = document.querySelector('h1.hdt-product__title, .hdt-product__title h1, .hdt-product__title');
    const infoCol = titleH1
      ? (titleH1.closest('.hdt-product-info__list, .hdt-product-info, .product__info, main .product') || titleH1.parentElement)
      : null;
    const root = infoCol ? infoCol.querySelector('.hdt-product__price, .hdt-price-wrapp, .product__price, .product-single__price') : null;
    if (root) {
      const s = root.querySelector(
        'hdt-compare-at-price .hdt-money, .hdt-compare-at-price .hdt-money, ' +
        'hdt-compare-at-price, .hdt-compare-at-price, ' +
        's, del, [class*="compare"]'
      );
      if (s) {
        const m = (s.textContent||'').replace(/\s/g,'').match(/[\d,]+(?:\.\d+)?/);
        if (m) return Math.round(parseFloat(m[0].replace(/,/g,'')) * 100);
      }
    }
    return 0;
  }
  function calcSavePercent(currentBaht, compareBaht) {
    if (!compareBaht || compareBaht <= currentBaht) return 0;
    return Math.round(((compareBaht - currentBaht) / compareBaht) * 100);
  }

  /* Product-level save %: pick the largest discount % across all variants
     and use it consistently. SleepHappy's pricing strategy is "same % off
     for every size" — but Shopify often only stores compare_at_price on
     the default variant, leaving others null. We mirror the % so every
     variant shows the same savings (matching real-world expectation). */
  function getProductSavePercent() {
    const p = window.__SH_product;
    if (!p || !p.variants) return 0;
    let maxPct = 0;
    for (const v of p.variants) {
      if (v.compare_at_price && v.price && v.compare_at_price > v.price) {
        const pct = Math.round(((v.compare_at_price - v.price) / v.compare_at_price) * 100);
        if (pct > maxPct) maxPct = pct;
      }
    }
    return maxPct;
  }

  /* Build variant selector pill — shows current variant title, opens sheet on click.
     Returns empty string if product has only 1 variant (no point showing picker). */
  function buildVariantPillHtml() {
    const p = window.__SH_product;
    if (!p || !p.variants || p.variants.length < 2) return '';
    const current = p.variants.find(v => String(v.id) === String(productVariantId)) || p.variants[0];
    const label = current.title || '';
    const chevron = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    return '<button type="button" class="sh-psb__variant" data-sh-psb-variant>' +
      '<span class="sh-psb__variant-text">' + label + '</span>' + chevron + '</button>';
  }

  /* Bottom sheet for variant selection. Casper-style modal centered on desktop,
     slides up from bottom on mobile. */
  function buildVariantSheet() {
    if (document.getElementById('sh-psb-sheet')) return;
    const sheet = document.createElement('div');
    sheet.id = 'sh-psb-sheet';
    sheet.className = 'sh-psb-sheet';
    sheet.innerHTML =
      '<div class="sh-psb-sheet__backdrop" data-sh-sheet-close></div>' +
      '<div class="sh-psb-sheet__panel">' +
        '<button type="button" class="sh-psb-sheet__close" data-sh-sheet-close aria-label="Close">×</button>' +
        '<div class="sh-psb-sheet__head" data-sh-sheet-head></div>' +
        '<div class="sh-psb-sheet__body" data-sh-sheet-body></div>' +
      '</div>';
    document.body.appendChild(sheet);
    sheet.querySelectorAll('[data-sh-sheet-close]').forEach(el =>
      el.addEventListener('click', closeVariantSheet)
    );
  }

  function openVariantSheet() {
    buildVariantSheet();
    const sheet = document.getElementById('sh-psb-sheet');
    const head = sheet.querySelector('[data-sh-sheet-head]');
    const body = sheet.querySelector('[data-sh-sheet-body]');
    const p = window.__SH_product;
    const optionName = (p.options && p.options[0]) || (LOCALE === 'th' ? 'ตัวเลือก' : 'Options');
    head.textContent = optionName;
    body.innerHTML = '<ul class="sh-psb-sheet__list">' +
      p.variants.map(v => {
        const active = String(v.id) === String(productVariantId);
        const disabled = !v.available;
        return '<li><button type="button" class="sh-psb-sheet__opt' +
          (active ? ' sh-psb-sheet__opt--active' : '') +
          (disabled ? ' sh-psb-sheet__opt--disabled' : '') +
          '" data-sh-sheet-vid="' + v.id + '"' + (disabled ? ' disabled' : '') + '>' +
          (v.title || '') +
          (disabled ? ' <span class="sh-psb-sheet__sold">(' + (LOCALE === 'th' ? 'หมด' : 'Sold out') + ')</span>' : '') +
          '</button></li>';
      }).join('') + '</ul>';
    body.querySelectorAll('[data-sh-sheet-vid]').forEach(btn =>
      btn.addEventListener('click', () => selectVariantFromSheet(btn.getAttribute('data-sh-sheet-vid')))
    );
    sheet.classList.add('sh-psb-sheet--open');
    document.body.classList.add('sh-psb-sheet-locked');
  }

  function closeVariantSheet() {
    const sheet = document.getElementById('sh-psb-sheet');
    if (sheet) sheet.classList.remove('sh-psb-sheet--open');
    document.body.classList.remove('sh-psb-sheet-locked');
  }

  /* Select variant by id: sync with theme's variant picker (radio inputs).
     Then trigger our own refresh so price + bar update without page reload. */
  function selectVariantFromSheet(vid) {
    const p = window.__SH_product;
    const v = p.variants.find(x => String(x.id) === String(vid));
    if (!v) return;
    /* Find option inputs by name (matches HaloThemes radio pattern). */
    p.options.forEach((optName, idx) => {
      const optValue = v['option' + (idx + 1)];
      if (optValue == null) return;
      /* Try radio inputs with name="OptionName" first */
      const radios = document.querySelectorAll('input[type="radio"][name="' + CSS.escape(optName) + '"]');
      let found = false;
      radios.forEach(r => {
        if (r.value === optValue) {
          r.checked = true;
          r.dispatchEvent(new Event('change', { bubbles: true }));
          r.dispatchEvent(new Event('input', { bubbles: true }));
          found = true;
        }
      });
      if (!found) {
        /* Try select dropdowns */
        const sel = document.querySelector('select[name="' + CSS.escape(optName) + '"]');
        if (sel) {
          sel.value = optValue;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
    /* Update productVariantId immediately so bar reflects choice */
    productVariantId = String(v.id);
    currentPriceCents = v.price;
    setTimeout(() => {
      readCurrentPrice();
      applyCartStateClasses();
      updatePdpStickyBar();
      updateRibbon();
      updatePdpBadge();
    }, 100);
    closeVariantSheet();
  }

  /* When PDP has er-buyx-gety bundle, read its TOTAL price (incl. free items)
     so sticky bar reflects the deal customer is actually committing to. */
  function readBundleTotal() {
    const bundle = document.querySelector('.er-buyx-gety');
    if (!bundle) return null;
    /* Sum all BUY card totals in cents (free items have variant.price 0) */
    const buyCards = bundle.querySelectorAll('.er-buyx-gety__pr-item-buy');
    let totalCents = 0;
    let foundAny = false;
    buyCards.forEach(card => {
      try {
        const variantsJson = card.getAttribute('data-variants');
        const sel = card.querySelector('select[name="er-buyx-gety__select"]');
        const currentId = (sel && sel.value) || card.getAttribute('data-current-id');
        const qty = parseInt(card.getAttribute('data-er-quantity') || '1', 10);
        if (!variantsJson || !currentId) return;
        const variants = JSON.parse(variantsJson);
        const v = variants.find(x => String(x.id) === String(currentId)) || variants[0];
        if (!v) return;
        totalCents += (v.price || 0) * qty;
        foundAny = true;
      } catch(_) {}
    });
    /* Add GET (free) items at zero — bundle layout shows them as included */
    return foundAny ? totalCents : null;
  }

  function buildPricerowHtml() {
    /* OPTION C: when bundle exists, prefer bundle total over individual variant */
    const bundleCents = readBundleTotal();
    const isBundle = bundleCents !== null && bundleCents > 0;
    const currentBaht = isBundle ? bundleCents / 100 : centsToBaht(getTotalPriceCents());
    let compareBaht = isBundle ? 0 : centsToBaht(getCompareAtCents());
    let save = calcSavePercent(currentBaht, compareBaht);

    /* Back-calculate compare if missing for variant */
    if (!isBundle && save === 0) {
      const productSave = getProductSavePercent();
      if (productSave > 0) {
        save = productSave;
        compareBaht = Math.round(currentBaht / (1 - productSave / 100));
      }
    }

    const lblComp = LOCALE === 'th' ? 'ราคาปกติ' : 'Comp. Value';
    const lblSave = LOCALE === 'th' ? 'ลด' : 'SAVE';
    const lblBundle = LOCALE === 'th' ? 'ราคาแพ็ค' : 'Bundle';
    let html = '';
    if (isBundle) {
      html += '<span class="sh-psb__bundle-tag">' + lblBundle + '</span>';
    }
    html += '<span class="sh-psb__price">' + fmtTHB(currentBaht) + '</span>';
    if (save > 0) {
      html += '<span class="sh-psb__save">' + lblSave + ' ' + save + '%</span>';
      html += '<span class="sh-psb__compare">' + lblComp + ' <s>' + fmtTHB(compareBaht) + '</s></span>';
    }
    return html;
  }

  function pdpStickyButtonsHtml(inCart) {
    const lblAdd = LOCALE === 'th' ? 'หยิบใส่ตะกร้า' : 'Add to cart';
    const lblCart = LOCALE === 'th' ? 'ตรวจสอบคำสั่งซื้อ' : 'View Cart';
    const lblBuy = LOCALE === 'th' ? 'ชำระเงิน' : 'Check out';
    if (inCart) {
      return '<button type="button" class="sh-psb__btn sh-psb__btn--outline" data-sh-psb-cart>' + lblCart + '</button>' +
             '<button type="button" class="sh-psb__btn sh-psb__btn--primary" data-sh-psb-checkout>' + lblBuy + '</button>';
    }
    return '<button type="button" class="sh-psb__btn sh-psb__btn--primary sh-psb__btn--wide" data-sh-psb-add>' + lblAdd + '</button>';
  }

  function buildPdpStickyBar() {
    if (!isProductPage()) return false;
    if (document.getElementById('sh-pdp-sticky')) return true;

    const bar = document.createElement('div');
    bar.id = 'sh-pdp-sticky';
    bar.className = 'sh-psb';
    const imgUrl = getPdpProductImageUrl();
    const title = getPdpProductTitle();
    const inCart = isVariantInCart(productVariantId);

    bar.innerHTML =
      '<div class="sh-psb__info">' +
        (imgUrl ? '<img class="sh-psb__thumb" src="' + imgUrl + '" alt="" loading="lazy">' : '<span class="sh-psb__thumb sh-psb__thumb--blank"></span>') +
        '<div class="sh-psb__meta">' +
          '<span class="sh-psb__titlerow">' +
            '<span class="sh-psb__title">' + title + '</span>' +
            '<span class="sh-psb__variantwrap" data-sh-psb-variantwrap>' + buildVariantPillHtml() + '</span>' +
          '</span>' +
          '<span class="sh-psb__pricerow" data-sh-psb-pricerow>' + buildPricerowHtml() + '</span>' +
        '</div>' +
      '</div>' +
      '<div class="sh-psb__actions" data-sh-psb-actions>' + pdpStickyButtonsHtml(inCart) + '</div>';

    document.body.appendChild(bar);
    wirePdpStickyBarEvents();
    return true;
  }

  function updatePdpStickyBar() {
    const bar = document.getElementById('sh-pdp-sticky');
    if (!bar) return;
    const priceRow = bar.querySelector('[data-sh-psb-pricerow]');
    if (priceRow) priceRow.innerHTML = buildPricerowHtml();
    const variantWrap = bar.querySelector('[data-sh-psb-variantwrap]');
    if (variantWrap) variantWrap.innerHTML = buildVariantPillHtml();
    const actions = bar.querySelector('[data-sh-psb-actions]');
    if (actions) {
      const inCart = isVariantInCart(productVariantId);
      actions.innerHTML = pdpStickyButtonsHtml(inCart);
    }
    wirePdpStickyBarEvents();
  }

  function wirePdpStickyBarEvents() {
    const bar = document.getElementById('sh-pdp-sticky');
    if (!bar) return;
    const variantBtn = bar.querySelector('[data-sh-psb-variant]');
    if (variantBtn) variantBtn.addEventListener('click', openVariantSheet);
    const addBtn = bar.querySelector('[data-sh-psb-add]');
    const cartBtn = bar.querySelector('[data-sh-psb-cart]');
    const buyBtn = bar.querySelector('[data-sh-psb-checkout]');
    if (addBtn) {
      addBtn.addEventListener('click', () => {
        if (isProductPage()) readCurrentPrice();
        if (!productVariantId) return;
        const qty = readCurrentQuantity();
        addBtn.disabled = true;
        addBtn.textContent = LOCALE === 'th' ? 'กำลังเพิ่ม…' : 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: productVariantId, quantity: qty })
        })
          .then(() => refreshCartState())
          .then(() => { updatePdpStickyBar(); refreshLineItems && refreshLineItems(); })
          .catch(() => { addBtn.disabled = false; addBtn.textContent = LOCALE === 'th' ? 'หยิบใส่ตะกร้า' : 'Add to cart'; });
      });
    }
    if (cartBtn) cartBtn.addEventListener('click', () => { location.href = '/cart'; });
    if (buyBtn) buyBtn.addEventListener('click', () => { goToCheckout(); });
  }

  // ─── 10c. QUICK VIEW MODAL INSTALLMENT BADGE ────────────────────────────
  // HaloThemes ships #hdt-quick-view-modal which mirrors the PDP product info
  // (price + variant picker + buy buttons) without navigating. We inject the
  // same navy installment hero card so customers can see the per-month price
  // without leaving the collection page.
  function readPriceFromContainer(container) {
    // Look for the most current sale price (fallback to regular).
    const sale = container.querySelector('.hdt-price__sale, .price__sale, [class*="price__sale"]');
    const reg  = container.querySelector('.hdt-price__regular, .price__regular, [class*="price__regular"]');
    const any  = container.querySelector('[class*="price-item"], [class*="price"]');
    const node = sale || reg || any;
    if (!node) return null;
    const txt = node.textContent || '';
    // Extract all numbers (handle "7,000.00" or "7000.00")
    const matches = txt.replace(/\s/g, '').match(/[\d,]+(?:\.\d+)?/g) || [];
    const nums = matches.map(s => parseFloat(s.replace(/,/g, ''))).filter(n => n > 0);
    if (!nums.length) return null;
    // Use the LOWEST shown number — that's the current effective price for
    // sale items. For ranges ("฿7,000 - ฿10,400") we anchor to the min so the
    // installment never overstates monthly cost.
    return Math.min.apply(null, nums);
  }

  /* Find the currently-visible HaloThemes modal — there are TWO IDs the theme
     uses: hdt-quick-view-modal AND hdt-quick-add-modal. Either may be open. */
  function getActiveQuickModal() {
    const ids = ['hdt-quick-add-modal', 'hdt-quick-view-modal'];
    for (const id of ids) {
      const m = document.getElementById(id);
      if (m && isQuickViewVisible(m)) return m;
    }
    return null;
  }

  function buildQuickViewBadge() {
    const modal = getActiveQuickModal();
    if (!modal) return false;
    const priceContainer = modal.querySelector('.hdt-product__price, [class*="product__price"]');
    if (!priceContainer) return false;
    const baht = readPriceFromContainer(priceContainer);
    if (!baht || baht < 1) return false;

    const tier = getTier(baht);
    const isRescue = tier.months === 0;
    const gapBaht = isRescue ? Math.max(1, 3000 - baht) : 0;
    if (isRescue && gapBaht > CONFIG.rescueMaxGap) {
      // Smart hide for cheap accessories
      const existing = modal.querySelector('.sh-pdp-inst-badge');
      if (existing) existing.remove();
      return true;
    }
    const perMonth = isRescue ? 0 : monthlyCost(baht, tier.months);
    const bodyHtml = isRescue ? pdpBadgeRescueHtml(gapBaht) : pdpBadgeBodyHtml(tier.months, perMonth);

    let badge = modal.querySelector('.sh-pdp-inst-badge');
    if (badge) {
      // Update in place
      badge.classList.toggle('sh-pdp-inst-badge--rescue', isRescue);
      const body = badge.querySelector('[data-sh-pdp-text]');
      if (body) body.innerHTML = bodyHtml;
      return true;
    }

    badge = document.createElement('div');
    badge.className = 'sh-pdp-inst-badge sh-pdp-inst-badge--block sh-pdp-inst-badge--quickview' + (isRescue ? ' sh-pdp-inst-badge--rescue' : '');
    badge.setAttribute('role', 'button');
    badge.setAttribute('tabindex', '0');
    badge.innerHTML = `
      <div class="sh-pdp-inst-badge__icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="2" y="5" width="20" height="14" rx="2"/>
          <line x1="2" y1="10" x2="22" y2="10"/>
          <line x1="6" y1="15" x2="10" y2="15"/>
        </svg>
      </div>
      <div class="sh-pdp-inst-badge__body" data-sh-pdp-text>${bodyHtml}</div>
      <div class="sh-pdp-inst-badge__chevron" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="9 18 15 12 9 6"/>
        </svg>
      </div>
    `;
    badge.addEventListener('click', openModal);
    badge.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openModal(); } });

    // Insert AFTER price (above variant picker / description)
    const priceWrap = priceContainer.closest('.hdt-product-info__item') || priceContainer;
    priceWrap.parentNode.insertBefore(badge, priceWrap.nextSibling);
    return true;
  }

  function isQuickViewVisible(modal) {
    if (!modal) return false;
    if (modal.hasAttribute('open')) return true;
    const cs = getComputedStyle(modal);
    if (cs.display === 'none' || cs.visibility === 'hidden') return false;
    return modal.getBoundingClientRect().width > 100;
  }

  // Global click delegation: more reliable than MutationObserver because
  // HaloThemes opens the modal via showModal()/class swap which is hard to
  // detect in time. We catch the click, then poll for the modal to render.
  function setupQuickViewClickHook() {
    if (window.__shQVHooked) return true;
    window.__shQVHooked = true;
    /* Strategy: 2 layers — (a) click delegation for fast response, (b) periodic
       poll to catch any modal opening we missed (some triggers don't bubble or
       use shadow DOM). Both call the same builder which is idempotent. */
    document.addEventListener('click', (e) => {
      const trig = e.target.closest(
        '.hdt-card-product__btn-quick-view,' +
        '.hdt-card-product__btn-ultra,' +     /* "เพิ่มลงในตะกร้า" — opens quick add modal for variant products */
        '[class*="btn-quick-view"],' +
        '[class*="quick-view-btn"],' +
        '[class*="card-product__btn-ultra"],' +
        '[data-action="quick-view"],' +
        '[data-action="quick-add"]'
      );
      if (!trig) return;
      // Wipe any stale badge from previous product so we never show wrong price.
      document.querySelectorAll('#hdt-quick-view-modal .sh-pdp-inst-badge, #hdt-quick-add-modal .sh-pdp-inst-badge').forEach(el => el.remove());
      const modal = getActiveQuickModal();
      if (modal) modal.dataset.shVariantWatch = '0';
      pollForQuickView(30, 150);
    }, true);

    /* Safety-net periodic poll: every 800ms check if modal is open + has no
       badge → build. Catches modals opened by triggers we didn't catch. */
    setInterval(() => {
      const m = getActiveQuickModal();
      if (!m || !isQuickViewVisible(m)) return;
      if (m.querySelector('.sh-pdp-inst-badge')) return;
      if (buildQuickViewBadge()) wireQuickViewVariantWatch(m);
    }, 800);
    return true;
  }

  function pollForQuickView(maxTries, intervalMs) {
    let tries = 0;
    const poll = () => {
      const m = getActiveQuickModal();
      if (m && isQuickViewVisible(m)) {
        if (buildQuickViewBadge()) { wireQuickViewVariantWatch(m); return; }
      }
      if (++tries < maxTries) setTimeout(poll, intervalMs);
    };
    setTimeout(poll, 50);
  }

  function wireQuickViewVariantWatch(modal) {
    if (!modal || modal.dataset.shVariantWatch === '1') return;
    modal.dataset.shVariantWatch = '1';

    // Variant pickers fire change on radio/select — most reliable signal.
    modal.addEventListener('change', (e) => {
      const t = e.target;
      if (t && (t.matches('input[type="radio"], select') ||
                (t.closest && t.closest('hdt-variant-picker, [class*="variant-picker"]')))) {
        setTimeout(buildQuickViewBadge, 60);
        setTimeout(buildQuickViewBadge, 250);
      }
    });
    modal.addEventListener('click', (e) => {
      // Pill / swatch buttons may not fire change — listen for any click on
      // option labels/buttons inside the picker.
      if (e.target.closest('label, .hdt-variant-picker__option, [class*="variant"], [class*="swatch"]')) {
        setTimeout(buildQuickViewBadge, 100);
        setTimeout(buildQuickViewBadge, 300);
      }
    });

    // Narrow-scope MutationObserver on price element only — avoids loops
    // from our own badge insertion further up the modal tree.
    const priceEl = modal.querySelector('.hdt-product__price, [class*="product__price"]');
    if (priceEl) {
      const obs = new MutationObserver(() => {
        if (modal.dataset.shBuilding === '1') return;
        modal.dataset.shBuilding = '1';
        buildQuickViewBadge();
        setTimeout(() => { modal.dataset.shBuilding = '0'; }, 80);
      });
      obs.observe(priceEl, { childList: true, subtree: true, characterData: true });
    }
  }

  // ─── 10b. PDP DESCRIPTION READ-MORE ──────────────────────────────────────
  // Some products have very long descriptions (Atlantis Lite, mattresses).
  // Collapse them with a fade overlay + branded "อ่านต่อ" pill button so the
  // page stays scannable while preserving full content for shoppers who care.
  /* Short product description (top of PDP) — clamp to 3 lines + inline toggle */
  function setupShortDescriptionClamp() {
    if (!isProductPage()) return false;
    const desc = document.querySelector('.hdt-product__description');
    if (!desc) return false;
    if (desc.dataset.shClampApplied === '1') return true;
    if ((desc.textContent || '').trim().length < 80) { desc.dataset.shClampApplied = 'short'; return true; }
    desc.dataset.shClampApplied = '1';
    desc.classList.add('sh-desc-clamp');

    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'sh-desc-toggle';
    toggle.setAttribute('aria-expanded', 'false');
    const labelMore = LOCALE === 'th' ? 'อ่านเพิ่ม' : 'Read more';
    const labelLess = LOCALE === 'th' ? 'ย่อ' : 'Show less';
    toggle.innerHTML =
      '<span class="sh-desc-toggle__text">' + labelMore + '</span>' +
      '<svg class="sh-desc-toggle__chevron" width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
      '<path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    toggle.addEventListener('click', () => {
      const isOpen = desc.classList.toggle('sh-desc-expanded');
      toggle.classList.toggle('sh-desc-toggle--open', isOpen);
      toggle.setAttribute('aria-expanded', String(isOpen));
      toggle.querySelector('.sh-desc-toggle__text').textContent = isOpen ? labelLess : labelMore;
    });
    desc.parentNode.insertBefore(toggle, desc.nextSibling);
    return true;
  }

  const RM_SELECTORS = [
    /* HaloThemes accordion: "รายละเอียดสินค้า" → big rich-text inside details */
    'details.hdt-product-accordion__item .hdt-product-accordion__content.hdt-rte',
    '.hdt-product-accordion__content.hdt-rte',
    /* Tab-style description */
    '.hdt-tab-content .rte',
    '.hdt-tab-content .hdt-rte',
    /* Short product info description (top of PDP) */
    '.hdt-product__description',
    '.product__description .rte',
    '.product__description',
    '.product-single__description',
    '.product-description .rte',
    '.product-description',
    '[class*="product-description"] .rte',
    '.hdt-product-description'
  ];
  const RM_COLLAPSED_PX = 360;

  function setupDescriptionReadMore() {
    if (!isProductPage()) return false;
    let target = null;
    for (const sel of RM_SELECTORS) {
      const candidates = document.querySelectorAll(sel);
      for (const el of candidates) {
        if (el.dataset.shReadmore === '1') return true;
        if (el.textContent && el.textContent.trim().length > 220) { target = el; break; }
      }
      if (target) break;
    }
    if (!target) return false;
    const fullH = target.scrollHeight;
    if (fullH <= RM_COLLAPSED_PX + 80) { target.dataset.shReadmore = 'short'; return true; }

    target.dataset.shReadmore = '1';
    target.classList.add('sh-rm-content', 'sh-rm-collapsed');
    target.style.setProperty('--sh-rm-max', RM_COLLAPSED_PX + 'px');

    const wrap = document.createElement('div');
    wrap.className = 'sh-rm-toggle-wrap';
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'sh-rm-toggle';
    btn.setAttribute('aria-expanded', 'false');
    const labelMore = LOCALE === 'th' ? 'อ่านรายละเอียดเพิ่มเติม' : 'Read more';
    const labelLess = LOCALE === 'th' ? 'ย่อเนื้อหา' : 'Show less';
    btn.innerHTML =
      '<span class="sh-rm-toggle__text">' + labelMore + '</span>' +
      '<svg class="sh-rm-toggle__chevron" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
      '<path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    btn.addEventListener('click', () => {
      target.classList.toggle('sh-rm-collapsed');
      const isCollapsedNow = target.classList.contains('sh-rm-collapsed');
      btn.setAttribute('aria-expanded', String(!isCollapsedNow));
      btn.querySelector('.sh-rm-toggle__text').textContent = isCollapsedNow ? labelMore : labelLess;
      btn.classList.toggle('sh-rm-toggle--open', !isCollapsedNow);
      if (isCollapsedNow) {
        const top = target.getBoundingClientRect().top + window.scrollY - 120;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    });
    wrap.appendChild(btn);
    target.parentNode.insertBefore(wrap, target.nextSibling);
    return true;
  }

  // ─── 11. INIT ────────────────────────────────────────────────────────────
  function init() {
    buildModal();
    // Ribbon is built on every page. Visibility is controlled by
    // positionRibbon() based on cart state + page type.
    buildRibbon();

    if (isProductPage()) {
      readCurrentPrice();
      // Retry badge build — anchors (variant picker, price container) can
      // render after DOMContentLoaded on themes with deferred web components.
      // Keep trying until we successfully insert OR run out of attempts.
      let badgeTries = 0;
      const tryBuildBadge = () => {
        if (document.querySelector('.sh-pdp-inst-badge')) return;
        const ok = buildPdpBadge();
        if (ok === false && ++badgeTries < 15) setTimeout(tryBuildBadge, 400);
      };
      tryBuildBadge();
      observeStickyATC();
      listenVariantChange();
      /* F-58.22 (2026-04-29): Install persistent SVG icon guardian — retry until
         line1 is in DOM (sticky button can render after DOMContentLoaded on slow
         pages, same retry pattern as wireStickyCheckout below). */
      let _shIconTries = 0;
      const _shInstallIconGuard = () => {
        if (installShStickyIconGuardian()) return;
        if (++_shIconTries < 20) setTimeout(_shInstallIconGuard, 300);
      };
      _shInstallIconGuard();
      /* F-56 (2026-04-28): V8 size picker modal init — retry if modal markup
         not in DOM yet (theme may render product section async). */
      let v8Tries = 0;
      const tryInitV8 = () => {
        if (document.querySelector('[data-sh-modal]')) {
          initV8Modal();
          return;
        }
        if (++v8Tries < 15) setTimeout(tryInitV8, 400);
      };
      tryInitV8();
      // Wire Check out button into the theme's sticky ATC bar. Retry because
      // hdt-sticky-btn-atc can render after DOMContentLoaded on slower pages.
      let stickyTries = 0;
      const wireStickyCheckout = () => {
        if (injectCheckoutNextToStickyAtc()) return;
        if (++stickyTries < 20) setTimeout(wireStickyCheckout, 300);
      };
      wireStickyCheckout();

      // Buy-X-Get-Y bundle: hint lives inside the bundle card itself AND the
      // card becomes the authoritative price source for PDP badge + ribbon.
      let tries = 0;
      const wireBundle = () => {
        if (observeBundleCards()) return;
        if (++tries < 20) setTimeout(wireBundle, 250);
      };
      wireBundle();

      // Read-more for long product descriptions. Description tab can render
      // late on themes with deferred web components — retry until found.
      let rmTries = 0;
      const wireReadMore = () => {
        if (setupDescriptionReadMore()) return;
        if (++rmTries < 20) setTimeout(wireReadMore, 350);
      };
      wireReadMore();

      /* Short description 3-line clamp (top of PDP, separate from accordion) */
      let scTries = 0;
      const wireShortClamp = () => {
        if (setupShortDescriptionClamp()) return;
        if (++scTries < 20) setTimeout(wireShortClamp, 300);
      };
      wireShortClamp();

      // Sticky ATC bar (custom). Wait a beat for variant picker / image to
      // render so we have title + price + thumbnail to show.
      let psbTries = 0;
      const wireStickyBar = () => {
        if (buildPdpStickyBar()) return;
        if (++psbTries < 20) setTimeout(wireStickyBar, 300);
      };
      wireStickyBar();
    }

    buildCheckoutBar();

    // Universal listeners — ribbon shows on any page when cart has items.
    window.addEventListener('scroll', scheduleRibbonReposition, { passive: true });
    window.addEventListener('resize', scheduleRibbonReposition, { passive: true });

    // Initial ribbon paint (uses product price on PDP, hidden on non-PDP
    // until cart state arrives). Then refresh from /cart.js to flip the
    // ribbon into "cart total" mode if items exist.
    updateRibbon();
    positionRibbon();

    // Cart line-item installment hint (works on product pages with mini-cart
    // drawer AND on /cart page). Side-effect: updates cartState + ribbon.
    refreshLineItems();
    observeCartMutations();

    // After cart state arrives, sync sticky ATC bar (in-cart vs not)
    refreshCartState().then(() => updatePdpStickyBar());

    // Quick-View modal installment badge — global click delegation hook
    // catches quick-view trigger buttons even before modal exists in DOM.
    setupQuickViewClickHook();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Expose for debugging / QA
  window.SleepHappyPhase2 = {
    openModal, closeModal, updateRibbon, updatePdpBadge,
    refreshLineItems,
    getTier, getNextTier, locale: LOCALE, tiers: TIERS,
  };
})();



/* ==========================================================================
   F-58.X (2026-04-29): ROOT-CAUSE FIX — V12 sticky ATC font-weight stability
   --------------------------------------------------------------------------
   Halo's <hdt-sticky-btn-atc> custom element re-renders its entire DOM
   subtree on variant change. The freshly mounted <span class="sh-v12-primary__line1">
   sometimes inherits a different font instance / synthetic-bold from its
   <button class="hdt-font-semibold"> ancestor, causing visible weight drift.

   This MutationObserver enforces canonical inline styles on line1 + line2
   any time the sticky-atc subtree mutates. Inline styles win over Halo's
   class-based weights and over CSS specificity drift from class-set rebuild.
   ========================================================================== */
(function () {
  if (window.__shStickyAtcFontGuard) return;
  window.__shStickyAtcFontGuard = true;

  // F-74 (2026-05-01): soften — drop stroke 0.55, use weight 600 (Sarabun fallback gives correct boldness)
  const LINE1_INLINE =
    'font-weight:600 !important;' +
    'font-synthesis:none !important;' +
    '-webkit-text-stroke:0 !important;' +
    '-webkit-font-smoothing:antialiased !important;' +
    '-moz-osx-font-smoothing:grayscale !important;' +
    'text-rendering:geometricPrecision !important;';

  // F-74: line 2 lighter (was 600) — secondary subtitle hierarchy
  const LINE2_INLINE =
    'font-weight:500 !important;' +
    'font-synthesis:none !important;' +
    '-webkit-text-stroke:0 !important;';

  function enforce(scope) {
    if (!scope) return;
    const l1 = scope.querySelectorAll('.sh-v12-primary__line1');
    l1.forEach((el) => {
      if (el.getAttribute('data-sh-font-locked') !== '1') {
        el.style.cssText = (el.style.cssText || '') + ';' + LINE1_INLINE;
        el.setAttribute('data-sh-font-locked', '1');
      }
    });
    const l2 = scope.querySelectorAll('.sh-v12-primary__line2');
    l2.forEach((el) => {
      if (el.getAttribute('data-sh-font-locked') !== '1') {
        el.style.cssText = (el.style.cssText || '') + ';' + LINE2_INLINE;
        el.setAttribute('data-sh-font-locked', '1');
      }
    });
  }

  function watch() {
    const root = document.querySelector('hdt-sticky-btn-atc');
    if (!root) return;
    enforce(root);
    const obs = new MutationObserver(function (muts) {
      // Re-enforce; clear lock if the element was re-created by Halo
      muts.forEach(function (m) {
        m.addedNodes && m.addedNodes.forEach(function (n) {
          if (n.nodeType === 1) {
            // Newly added — strip old lock so we re-apply
            if (n.classList && (n.classList.contains('sh-v12-primary__line1') ||
                                n.classList.contains('sh-v12-primary__line2'))) {
              n.removeAttribute('data-sh-font-locked');
            }
            const inner = n.querySelectorAll &&
              n.querySelectorAll('.sh-v12-primary__line1,.sh-v12-primary__line2');
            if (inner) inner.forEach(function (e) { e.removeAttribute('data-sh-font-locked'); });
          }
        });
      });
      enforce(root);
    });
    obs.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
    // Safety net for any timing edge case Halo might create
    setInterval(function () { enforce(root); }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
  // Re-bind if hdt-sticky-btn-atc is itself replaced
  const bodyObs = new MutationObserver(function () {
    if (!document.querySelector('hdt-sticky-btn-atc[data-sh-font-watcher]')) {
      const r = document.querySelector('hdt-sticky-btn-atc');
      if (r) { r.setAttribute('data-sh-font-watcher', '1'); watch(); }
    }
  });
  bodyObs.observe(document.body, { childList: true, subtree: true });
})();

/* F-65 (2026-04-30): Show sticky ATC after 15% page scroll on mobile PDP.
   Reverted from element-anchored (IntersectionObserver on .shopify-payment-button)
   back to percentage-threshold per user preference. Tuning history same day:
   started at 30% → 20% → 10% → 15% (current).
   CSS in sh-installment-suite.css hides sticky by default via translateY(100%);
   this IIFE adds `.sh-sticky-shown` body class to trigger CSS slide-in. */
(function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (!window.matchMedia('(max-width: 1023px)').matches) return; /* Mobile only — F-45 hides sticky on desktop */

  function init() {
    var body = document.body;
    if (!body.classList.contains('template-product')) return; /* PDP only */

    var THRESHOLD = 0.15; /* 15% of scrollable height */
    var ticking = false;

    function checkScroll() {
      var scrollY = window.scrollY || window.pageYOffset || 0;
      var docHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      var scrollable = docHeight - window.innerHeight;
      /* Edge case: page too short to scroll meaningfully → show sticky as fallback */
      if (scrollable <= 0) {
        body.classList.add('sh-sticky-shown');
        ticking = false;
        return;
      }
      var ratio = scrollY / scrollable;
      body.classList.toggle('sh-sticky-shown', ratio >= THRESHOLD);
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(checkScroll);
        ticking = true;
      }
    }, { passive: true });

    /* Recalc on resize — iOS Safari URL bar show/hide changes innerHeight */
    window.addEventListener('resize', checkScroll, { passive: true });

    /* Initial check — covers cases where user landed mid-scroll (deep link, BFCache) */
    checkScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
